(function () {
	var Cache;
	WebBaseAprovLV.debug = ['dev', 'demo'].includes(WebBaseAprovLV.config.environment);
	// global config
	if (typeof (window.WebBaseAprovLV) === 'undefined') {
		window.WebBaseAprovLV = {};
	}

	WebBaseAprovLV.config = WebBaseAprovLV.config || {};
	WebBaseAprovLV.lang = WebBaseAprovLV.config.defaultLang || 'de';
	WebBaseAprovLV.i18n = {};
	WebBaseAprovLV.pagingWindow = 9;
	WebBaseAprovLV.version = {
		template: '2026-02-05T15:40:00.000Z',
		i18n: '2026-02-05T15:40:00.000Z'
	};

	Cache = (function () {
		function Cache() {
			this.count = 0;
			this.store = {};
		}
		Cache.prototype.get = function (key, callback) {
			if (key && key.length) {
				if (this.store[key]) {
					if (typeof callback === 'function') {
						callback.call(null, this.store[key]);
					}
					return this.store[key];
				}
			}
			return {
				timestamp: null,
				type: null,
				value: null
			};
		};
		Cache.prototype.set = function (key, value) {
			var old = null;
			if (key && key.length) {
				if (this.store[key]) {
					old = this.store[key];
				} else {
					// does not exist yet
					++this.count;
				}
				this.store[key] = {
					timestamp: (new Date).getTime(),
					type: key.match(/[^.]*/)[0],
					value: value
				};
			}
			return old || {
				timestamp: null,
				type: null,
				value: null
			};
		};
		Cache.prototype.del = function (key) {
			if (key && this.store[key]) {
				delete this.store[key];
				--this.count;
			}
			return null;
		};
		return Cache;
	})();
	WebBaseAprovLV.Cache = new Cache();

	// IE11 padstart fix
	if (!String.prototype.padStart) {
		String.prototype.padStart = function padStart(targetLength, padString) {
			targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
			padString = String((typeof padString !== 'undefined' ? padString : ' '));
			if (this.length > targetLength) {
				return String(this);
			} else {
				targetLength = targetLength - this.length;
				if (targetLength > padString.length) {
					padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
				}
				return padString.slice(0, targetLength) + String(this);
			}
		};
	}

	// global utils
	WebBaseAprovLV.Utils = {};
	WebBaseAprovLV.Utils.getTemplate = function (template) {
		return $.get(WebBaseAprovLV.config.templatesPath + template + '.ejs.html?v=' + WebBaseAprovLV.version.template);
	};

	WebBaseAprovLV.Utils.getKKData = function (parameters, altProjectId, retryCount = 0) {
		if (WebBaseAprovLV.debug) {
			console.log(
				'%c---\n%cCall getKKData and reset resetLastUpdateDateTime after %c\n ' + parameters,
				WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldRed,
				WebBaseAprovLV.Utils.LastUpdateDateTime.styleBold,
				WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultRed
			);
		}
		WebBaseAprovLV.Utils.LastUpdateDateTime.reset();
		var maxRetries = 3;
		var baseDelayMs = 1000;
		var jitterMs = 300;
		var apiUrl = WebBaseAprovLV.config.apiUrl || '';
		var apiHeaders = WebBaseAprovLV.config.apiHeaders || {};
		if ((altProjectId || '').length) {
			apiUrl = apiUrl.replace(WebBaseAprovLV.config.projectId, altProjectId);
		} else if (WebBaseAprovLV.config.apiUrlPreview && WebBaseAprovLV.config.apiHeadersPreview) {
			apiUrl = WebBaseAprovLV.config.apiUrlPreview;
			apiHeaders = WebBaseAprovLV.config.apiHeadersPreview;
		}
		function computeDelay(attempt) {
			return baseDelayMs * Math.pow(2, attempt) + Math.floor(Math.random() * jitterMs);
		}
		return $.ajax({
			url: (apiUrl + '/items' + parameters + '&system.language=' + WebBaseAprovLV.lang + '&language=' + WebBaseAprovLV.lang),
			type: 'GET',
			dataType: 'json',
			headers: apiHeaders
		}).fail(function (xhr, textStatus, errorThrown) {
			var status = (xhr && typeof xhr.status === 'number') ? xhr.status : -1;
			var isRetryable = (status === 425) || (status === 0);
			if (isRetryable && retryCount < maxRetries) {
				var delay = computeDelay(retryCount);
				console.warn(
					'getKKData retry ' + (retryCount + 1) + '/' + maxRetries +
					' in ' + delay + 'ms (status=' + status + ', textStatus=' + textStatus + ')'
				);
				return $.Deferred(function (d) {
					setTimeout(function () {
						WebBaseAprovLV.Utils.getKKData(parameters, altProjectId, retryCount + 1)
							.done(d.resolve)
							.fail(d.reject);
					}, delay);
				}).promise();
			}
			return $.Deferred().rejectWith(this, arguments).promise();
		});
	};
	
	WebBaseAprovLV.Utils.getTaxonomies = function (props, altProjectId) {
		var apiUrl = WebBaseAprovLV.config.apiUrl || '';
		var apiHeaders = WebBaseAprovLV.config.apiHeaders || {};
		if ((altProjectId || '').length) {
			apiUrl = apiUrl.replace(WebBaseAprovLV.config.projectId, altProjectId);
		} else if (WebBaseAprovLV.config.apiUrlPreview && WebBaseAprovLV.config.apiHeadersPreview) {
			apiUrl = WebBaseAprovLV.config.apiUrlPreview;
			apiHeaders = WebBaseAprovLV.config.apiHeadersPreview;
		}
		props = props || {};
		var groupname = props.groupname || '';
		if (groupname.length) {
			groupname = '/' + props.groupname;
		}
		return $.ajax({
			url: (apiUrl + '/taxonomies' + groupname),
			type: 'GET',
			dataType: 'json',
			headers: apiHeaders
		});
	};

	WebBaseAprovLV.Utils.getSearchData = function (parameters) {
		return $.getJSON(WebBaseAprovLV.config.noovleSearchApiUrl + parameters + '&callback=?');
	};


	WebBaseAprovLV.Utils.getWebGisData = function (parameters) {
		var currentOrigin = window.location.origin;
		return $.ajax({
			url: 'https://geoservices.buergernetz.bz.it/services/meteo/' + parameters,
			dataType: 'json',
			headers: {
				'Origin': currentOrigin
			}
		});
	};

	WebBaseAprovLV.Utils.getServiceEditorData = function (parameters) {
		// var secaEndpoint = 'https://api.integrations.services.siag.it/pub/cocweb/serviceeditor/civis/api/';
		var secaEndpoint = 'https://api.integrations.services.siag.it/pub/cocweb/serviceeditor/civis/api/';
		return $.getJSON(secaEndpoint + parameters)
			.catch(function (jqxhr, textStatus, error) {
				var err = ('Request Failed: ' + textStatus + ', ' + error);
				return { error: err };
			});
	};

	WebBaseAprovLV.Utils.getI18nData = function (parameters) {
		var params = parameters || {};
		var lang = params.lang || WebBaseAprovLV.lang;
		return WebBaseAprovLV.i18n[lang] ? $.Deferred().resolve(WebBaseAprovLV.i18n[lang]).then(function (i18n) { return [i18n]; }) : $.getJSON('i18n/' + lang + '.json?v=' + WebBaseAprovLV.version.i18n);
	};

	WebBaseAprovLV.Utils.fetchAsync = function (settings) {
		settings = $.extend({
			dataType: 'json',
			cache: true
		}, settings || {});
		return function (url, options) {
			options = $.extend(settings, options || {}, {
				url: url
			});
			return $.ajax(options);
		};
	};

	// Optionale Helfer: mappe 'de'|'it'|'lld'|'en' auf stabile BCP-47 Locales
	WebBaseAprovLV.Utils.localeFor = function (lang) {
		var L = (lang || '').toLowerCase();
		if (L === 'de' || L === 'lld') return 'de-DE';
		if (L === 'it') return 'it-IT';
		if (L === 'en') return 'en-GB';
		return 'de-DE';
	};

	/**
	 * Format a date/time with sane TZ handling.
	 * @param {string|number|Date} datetime   ISO string, epoch ms, or Date
	 * @param {'withtime'|'long'|'shortmonth'|'onlyday'|'onlytime'|''} format
	 * @param {object|string} [opts]          e.g. { timeZone:'UTC', locale:'de-DE' } or 'UTC'
	 */
	WebBaseAprovLV.Utils.formatDateTime = function (datetime, format, opts) {
		var options = {};
		var dttm;

		if (typeof datetime === 'string') {
			dttm = datetime.length ? new Date(datetime) : new Date();
		} else if (typeof datetime === 'number') {
			dttm = new Date(Number(datetime));
		} else if (Object.prototype.toString.call(datetime) === '[object Date]') {
			dttm = datetime;
		} else {
			dttm = new Date();
		}

		switch (format || '') {
			case 'withtime':
			options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
			break;
			case 'long':
			options = { weekday: 'long', year: 'numeric', month: 'long', day: '2-digit' };
			break;
			case 'shortmonth':
			options = { month: 'short' };
			break;
			case 'onlyday':
			options = { day: '2-digit' };
			break;
			case 'onlytime':
			options = { hour: '2-digit', minute: '2-digit' };
			break;
			default:
			options = { year: 'numeric', month: '2-digit', day: '2-digit' };
		}

		var locale = WebBaseAprovLV.Utils.localeFor(WebBaseAprovLV.lang);

		if (typeof opts === 'string') opts = { timeZone: opts };
		opts = opts && typeof opts === 'object' ? opts : {};

		if (opts.locale) locale = opts.locale;

		var tzDefault = (WebBaseAprovLV.config && WebBaseAprovLV.config.defaultTimeZone) || 'Europe/Rome';
		options.timeZone = opts.timeZone || tzDefault;

		try {
			return new Intl.DateTimeFormat(locale, options).format(dttm);
		} catch (e) {
			if (format === 'onlytime') return dttm.toLocaleTimeString(locale, options);
			return dttm.toLocaleString(locale, options);
		}
	};


	/**
	 * General observation timestamp for a weather station.
	 * Valley/mountain: always use the air-temperature sensor (LT), never a
	 * newer timestamp from a different measurement. Keep watercourse stations'
	 * previous behaviour because they do not necessarily have an LT sensor.
	 * Sensor-specific timestamps (LASTDATE) are not modified.
	 * @param {Array} sensors Sensors belonging to ONE station
	 * @param {string} stationType 'valley' | 'mountain' | 'watercourse'
	 * @returns {string} Sensor timestamp, or '-' if none is available
	 */
	WebBaseAprovLV.Utils.getStationObservationTimestamp = function (sensors, stationType) {
		if (!Array.isArray(sensors)) return '-';

		if (stationType !== 'watercourse') {
			var airTemperature = sensors.find(function (sensor) {
				return sensor && String(sensor.TYPE || '').toUpperCase() === 'LT';
			});
			return airTemperature && airTemperature.LASTDATE ? airTemperature.LASTDATE : '-';
		}

		// Preserve the existing summary timestamp for watercourse stations.
		var latest = null;
		sensors.forEach(function (sensor) {
			if (!sensor || !sensor.LASTDATE) return;
			var date = String(sensor.LASTDATE).trim();
			if (!date || date === '-' || date.toLowerCase() === 'unknown' ||
				date.toLowerCase() === 'invalid date') return;
			if (!latest || date > latest) latest = date;
		});
		return latest || '-';
	};

	WebBaseAprovLV.Utils.getUrlParameter = function (name) {
		var regex;
		var results;
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	};

	WebBaseAprovLV.Utils.text_truncate = function (str, length, ending) {
		if (length == null) {
			length = 100;
		}
		if (ending == null) {
			ending = '...';
		}
		if (str.length > length) {
			return str.substring(0, length - ending.length) + ending;
		} else {
			return str;
		}
	};

	WebBaseAprovLV.Utils.resolveBlankString = function (pGer, pIta, pLld) {
		if ((typeof pGer === 'string') || (typeof pIta === 'string') || (typeof pLld === 'string')) {
			if (WebBaseAprovLV.lang == 'it') {
				if (pIta != null) {
					return pIta.replace(/\n/g, '<br />');
				}
			} else if (WebBaseAprovLV.lang == 'lld') {
				if (pLld != null) {
					return pLld.replace(/\n/g, '<br />');
				}
			} else {
				if (pGer != null) {
					return pGer.replace(/\n/g, '<br />');
				}
			}
		} else if ((typeof pGer === 'number') || (typeof pIta === 'number') || (typeof pLld === 'number')) {
			if (WebBaseAprovLV.lang == 'it') {
				if (pIta != null) {
					return pIta;
				}
			} else if (WebBaseAprovLV.lang == 'lld') {
				if (pLld != null) {
					return pLld;
				}
			} else {
				if (pGer != null) {
					return pGer;
				}
			}
		}
	};


	WebBaseAprovLV.Utils.getCollectionBPyageSlugAndMenu = function (pageUrl, mainMenuContainer) {
		let collection = 'default';
		mainMenuContainer.forEach(function (menuPage) {
			if (menuPage.url === pageUrl) {
				return menuPage.system_collection;
			} else {
				if (typeof menuPage.subpages === 'object' && menuPage.subpages !== null && Object.keys(menuPage.subpages).length > 0) {
					WebBaseAprovLV.Utils.getCollectionBPyageSlugAndMenu(pageUrl, menuPage.subpages);
				}
			}
		});
		return collection;
	};

	WebBaseAprovLV.Utils.groupBy = function (list, keyGetter) {
		var map = new Map();
		list.forEach(function (item) {
			var key = keyGetter(item);
			var collection = map.get(key);
			if (!collection) {
				map.set(key, [item]);
			} else {
				collection.push(item);
			}
		});
		return map;
	};

	WebBaseAprovLV.Utils.replaceUrlParam = function (url, paramName, paramValue) {
		var pattern = new RegExp('\\b(' + (paramName || '') + '=).*?(&|#|$)');
		url = url || '';
		if ('number' === typeof paramValue) {
			paramValue = paramValue.toString(10);
		}
		if (Array.isArray(paramValue) || 'object' === typeof paramValue) {
			paramValue = encodeURIComponent(JSON.stringify(paramValue));
		}
		paramValue = paramValue || '';
		if (url.search(pattern) >= 0) {
			return url.replace(pattern, '$1' + paramValue + '$2');
		}
		url = url.replace(/[?#]$/, '');
		return url + (url.length > 0 ? '&' : '') + (paramName || '') + '=' + paramValue;
	};
	/**
	 * Fix Double Encoding / Facetted Search Comparison
	 */
	WebBaseAprovLV.Utils.quelixDoubleEncodeFix = function (inputString) {
		var replacements = {
			':': '%3A',
			'%7C': '%257C',
			'%C3%BC': '%25C3%25BC',
			'%C3%96': '%25C3%2596',
			'%20': '%2520',
			'%C3%AB': '%25C3%25AB',
			'%C3%A4': '%25C3%25A4',
			'%C3%B6': '%25C3%25B6',
			'%2F': '%252F',
			'%2C': '%252C',
			'%26': '%2526',
			'%C3%A0': '%25C3%25A0',
			'%C3%A1': '%25C3%25A1',
			'%C2%B4': '%25C2%25B4',
			'%E2%80%99': '%25E2%2580%2599',
			'%C3%B9': '%25C3%25B9',
			'%C3%9F': '%25C3%259F',
			'\'': '%2527',
			'\\(': '%2528',
			'\\)': '%2529'
		};
		for (var key in replacements) {
			if (replacements.hasOwnProperty(key)) {
				inputString = inputString.replace(new RegExp(key, 'g'), replacements[key]);
			}
		}
		return inputString;
	};
	WebBaseAprovLV.Utils.getLanguageHash = function (name) {
		var matches = location.hash.match(new RegExp(name || ''));
		return matches ? matches[0] : null;
	};
	/**
	 * Parse query string
	 * @param {string} querystring - The query string
	 * @returns {object} Pairs
	 * @example
	 * WebBaseAprovLV.Utils.parseQuerystring("?foo=Fritz&bar=Muster");
	 */
	WebBaseAprovLV.Utils.parseQuerystring = function (querystring) {
		var args = {};
		var qs = querystring && querystring.length > 0 && querystring[0] === '?' ? querystring.substring(1) : querystring || '';
		qs.split('&').forEach(function (item) {
			var kv = item.split(/=/);
			var k = kv[0] || '';
			if (k.length) {
				args[k] = kv[1] || '';
			}
		});
		return args;
	};
	/**
	 * Basic i18n gettext - translate a string
	 * @example
	 * WebBaseAprovLV.Utils.gettext("More");
	 */
	WebBaseAprovLV.Utils.gettext = function (msgid) {
		var i18n = WebBaseAprovLV.i18n;
		var lang = WebBaseAprovLV.lang || 'de';
		var dict = i18n ? i18n[lang] : null;
		return (dict && dict[msgid]) ? dict[msgid] : msgid;
	};
	/**
	 * Adjust the target urls of the language switching links
	 * @example
	 * WebBaseAprovLV.Utils.tuneUILangSwitchers(pageContent.items[0], $('a.langchange'));
	 */
	WebBaseAprovLV.Utils.tuneUILangSwitchers = function (props, $el) {
		var authorities = /prod/i.test(WebBaseAprovLV.config.environment || '') ? (WebBaseAprovLV.config.authorities || {}) : {};
		props = props || {};
		props.page = props.page || {};
		// segment names:  /{lang}/{ page segment name }/{ detail segment name }
		function getLinkSegment(part, lang) {
			var ret = '';
			var params = [];
			lang = lang || WebBaseAprovLV.lang;
			if ('object' === typeof part.segment) {
				// if segment is language map, get segment of specific lang
				if ((part.segment[lang] || '').length) {
					ret = part.segment[lang];
				}
			} else if ('string' === typeof part.segment) {
				ret = part.segment;
			} else {
				// if segment is not known or not defined
				if ((part.id || '').length) {
					params.push('system.id=' + encodeURIComponent(part.id));
				}
				if ((part.project_id || '').length) {
					params.push('project.id=' + encodeURIComponent(part.project_id));
				}
				ret = params.join('&');
			}
			return ret;
		}
		($el || $('a.langchange')).each(function () {
			var $that = $(this);
			var lang = ($that.attr('hreflang') || WebBaseAprovLV.lang);
			var segment = getLinkSegment(props.page, lang);	// page segment
			if (segment.length && props.detail && (!!props.detail.id || !!props.detail.segment)) {
				segment = segment + '/' + getLinkSegment(props.detail, lang); // detail segment
			}
			if (segment.length === 0) {
				segment = 'home';
			}
			$that.attr('href', [((authorities[lang] || '') + lang), segment].join('/'));
		});
		return props;
	};
	/**
	 * Get CSS class name of specific mime type. Note: It is project and CSS dependant.
	 * @param {string} mimetype - The mime type
	 * @returns {string} CSS class name
	 * @example
	 * var cssClass = WebBaseAprovLV.Utils.getMimetypeClassName("application/pdf");
	 */
	WebBaseAprovLV.Utils.getMimetypeClassName = function (mimetype) {
		var mime = mimetype || '';
		switch (true) {
			case /^application/i.test(mime):
				switch (true) {
					case /pdf$/.test(mime):
						return 'pdf';
					case /(word|rtf|opendocument\.text)/i.test(mime):
						return 'doc';
					case /(xls|excel|spreadsheet)/i.test(mime):
						return 'xls';
					case /(ppt|powerpoint|presentation)/i.test(mime):
						return 'ppt';
					case /(zip)/i.test(mime):
						return 'zip';
				}
				break;
			case /^text/i.test(mime):
				switch (true) {
					case /html$/.test(mime):
						return 'htm';
					case /(rtf|sgml|troff)$/.test(mime):
						return 'doc';
					case /(xml|csv)/i.test(mime):
						return 'xls';
				}
				break;
			case /^image/i.test(mime):
				return 'img';
			case /^audio/i.test(mime):
				return 'audio';
			case /^video/i.test(mime):
				return 'video';
		}
		return 'other';	// default, other, not classified
	};
	/**
	 * Remove dangerous characters from text and encode double and single quotes for attribute usage (xss)
	 * @param {string||number} attr - The string or number
	 * @returns {text} The cleaned string
	 */
	WebBaseAprovLV.Utils.toSafeAttribute = function (attr) {
		if ('string' === typeof attr && attr.length) {
			return attr.replace(/[\x00-\x1f\x3c\x3e"]/igm, '').replace(/\x22/g, '&quot;').replace(/\x27/g, '&#39;');
		}
		if ('number' === typeof attr) {
			return attr.toString(attr, 10);
		}
		return '';
	};
	/**
	 * Format bytes as human-readable text.
	 *
	 * @param bytes Number of bytes.
	 * @param si True to use metric (SI) units (1000), or binary (IEC) units (1024).
	 * @param dp Number of decimal places to display.
	 *
	 * @return Formatted string.
	 */
	WebBaseAprovLV.Utils.toHumanFileSize = function (bytes, si, dp) {
		var base;
		var units;
		var u = -1;
		var rem;
		si = !!si;
		dp = isNaN(dp) ? 0 : dp;
		base = si ? 1000 : 1024;
		units = si
			? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
			: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
		rem = Math.pow(10, dp);
		if (Math.abs(bytes) < base) {
			return bytes + ' B';
		}
		do {
			bytes /= base;
			++u;
		} while ((Math.round(Math.abs(bytes) * rem) / rem) >= base && u < units.length - 1);
		return bytes.toFixed(dp) + ' ' + (units[u] || '');
	};
	/**
	 * Translate link dependent on environment or other circumstances.
	 * @param {string} link - The link
	 * @returns {string} The transformed link
	 * @example
	 * var cssClass = WebBaseAprovLV.Utils.linkTo('/de/page');
	 */
	WebBaseAprovLV.Utils.linkTo = function (link) {
		// return /dev/i.test(WebBaseAprovLV.config.environment) ? ('#!' + link) : link;
		return link;
	};
	/**
	 * Translate action attribute dependent on environment or other circumstances.
	 * @param {string} link - The link
	 * @returns {string} The transformed link
	 * @example
	 * var cssClass = WebBaseAprovLV.Utils.actionTo('/de/page');
	 */
	WebBaseAprovLV.Utils.actionTo = function (link) {
		// return /dev/i.test(WebBaseAprovLV.config.environment) ? ('#!' + link) : link;
		return link;
	};

	/**
	 * Load template and render contents
	 * @param {object} options - Template, data and target element
	 * @returns {object} Promise
	 */
	WebBaseAprovLV.Utils.transitionTo = function (options) {
		return ejs.preloadTemplate(options.template)
			.then(function () {
				options.element.html(ejs.rr(options.template, options.data));
				return options;
			}).promise();
	};

	WebBaseAprovLV.Utils.LastUpdateDateTime = {
		styleBold: 'color:black; font-size:12px; font-weight:bold;',
		styleBoldGreen: 'color:#06cf94; font-size:12px; font-weight:bold;',
		styleBoldRed: 'color:red; font-size:12px; font-weight:bold;',
		styleBoldYellow: 'color:#f9d200; font-size:12px; font-weight:bold;',
		styleDefaultGreen: 'color:#06cf94; font-size:11px;font-weight:normal;',
		styleDefaultRed: 'color:red; font-size:11px;font-weight:normal;',
		styleDefaultYellow: 'color:#f9d200; font-style:italic; font-size:11px;font-weight:normal;'
	};

	/**
	 * reset LastUpdateDateTime
	 * @returns void
	 */
	WebBaseAprovLV.Utils.LastUpdateDateTime.reset = function () {
		//console.log('resetLastUpdateDateTime called');
		$('#lastUpdateBox').html('');
	};

	/**
	 * set lastUpdate in template
	 * @param {string} lastUpdateBoxText
	 * @returns void
	 */
	WebBaseAprovLV.Utils.LastUpdateDateTime.setDateTime = function (lastUpdateBoxText = '') {
		//console.log('LastUpdateDateTime.setDateTime called');
		$('#lastUpdateBox').html(lastUpdateBoxText);
	};

	/**
	 * set calc last update
	 * @param {array} elementsArr
	 * @param {string} lastUpdateDate
	 */
	WebBaseAprovLV.Utils.LastUpdateDateTime.calc = function (lastUpdateDate = '', elementsArr = []) {
		if (elementsArr.length !== 0) {
			let possibleContentTypes = {
				'homepage': 'default',
				'page': 'default',
				'icon_box_container': 'container',
				'icon_box_item': 'default',
				'box_container': 'container',
				'box_item': 'default',
				'image_and_text_section': 'default',
				'hilite_section': 'default',
				'serviceeditor_section': 'default',
				'collapse_container': 'container',
				'postcard_container': 'container',
				'postcard_item': 'default',
				'collapse_item': 'default',
				'news_homepage': 'default',
				'news_container': 'container',
				'news': 'default',
				'appointment_container': 'container',
				'appointment_item': 'default',
				'project_item': 'default',
				'youtube_video_item': 'default',
				'introduction_section': 'default',
				'serviceeditor_section': 'default'
			};
			for (key in elementsArr) {
				let item = elementsArr[key];
				// special content from search engine
				if (item && item.hasOwnProperty('MT') && item.MT.hasOwnProperty('documentType') && possibleContentTypes.hasOwnProperty(item.MT.documentType[0])) {
					lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.evaluateDateTime(
						{
							'system_type': item.MT.documentType[0],
							'date': item.MT.date[0],
							'script_report_results': item.script_report_results
						},
						lastUpdateDate
					);
				} else if (item && item.hasOwnProperty('system') && possibleContentTypes.hasOwnProperty(item.system.type)) {
					if (possibleContentTypes[item.system.type] === 'container') {
						for (containerItemKey in item.container) {
							lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.evaluateDateTime(item.container[containerItemKey].system, lastUpdateDate);
						}
					} else {
						lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.evaluateDateTime(item, lastUpdateDate);
					}
				} else {
					if (item && item.hasOwnProperty('system_type') && possibleContentTypes.hasOwnProperty(item.system_type)) {
						if (possibleContentTypes[item.system_type] === 'container') {
							for (containerItemKey in item.container) {
								if (possibleContentTypes.hasOwnProperty(item.container[containerItemKey].system_type)) {
									lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.evaluateDateTime(item.container[containerItemKey], lastUpdateDate);
								}
							}
						} else {
							lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.evaluateDateTime(item, lastUpdateDate);
						}
					}
				}
			}
		};
		return lastUpdateDate;
	};

	/**
	 * evaluate  last update time and get back the newsest
	 * @param {array} elementsArr
	 * @param {string} lastUpdateDate
	 * @returns {string} lastUpdateDate
	 */
	WebBaseAprovLV.Utils.LastUpdateDateTime.evaluateDateTime = function (item, lastUpdateDate) {
		let checkDate = '';
		let systemType = item.system_type ? item.system_type : item.system.type;
		let systemId = item.script_report_results
			? item.script_report_results
			: (item.hasOwnProperty('system_id') ? item.system_id : item.system.id);
		if (systemType === 'news') {
			checkDate = item.hasOwnProperty('elements')
				? item.elements.date.value
				: item.date;
		} else {
			checkDate = item.system_last_modified;
		}

		// create date time tomorrow at 00:01
		let tomorrowDate = new Date();
		tomorrowDate.setDate(tomorrowDate.getDate() + 1);
		tomorrowDate.setUTCHours(0, 0, 0, 0);
		let todayAtMidnightDate = tomorrowDate.toISOString().slice(0, 19) + 'Z';

		// create date time one year ago
		let oneYearAgo = new Date();
		oneYearAgo.setFullYear(new Date().getFullYear() - 1);
		oneYearAgo.setUTCHours(0, 0, 0, 0);
		let oneYearAgoDate = oneYearAgo.toISOString().slice(0, 19) + 'Z';

		// check if date is not older then 1 year, not newer today and higher then last last date
		if (checkDate > oneYearAgoDate && checkDate < todayAtMidnightDate && checkDate > lastUpdateDate) {
			if (WebBaseAprovLV.debug) {
				console.log(
					'%c+++\n%cCheck date: %c' + checkDate + ' %cis newer than: %c' + (lastUpdateDate ? lastUpdateDate : 'null')
					+ ' %c\nItem_type: %c' + systemType + ' %c\nItem_id: %c' + systemId,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldGreen,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBold,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultGreen,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBold,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultGreen,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBold,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultGreen,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBold,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultGreen
				);
			}
			return checkDate;
		} else {
			if (WebBaseAprovLV.debug) {
				let comparsionOperatorLabel = checkDate > todayAtMidnightDate ? 'is in future than: ' : 'is older than: ';
				console.log(
					'%c~~~\n%cCheck date: %c' + checkDate + ' %c' + comparsionOperatorLabel + '%c' + (lastUpdateDate ? lastUpdateDate : 'null')
					+ ' %c\nItem_type: %c' + systemType + ' %c\nItem_id: %c' + systemId,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldRed,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleBoldYellow,
					WebBaseAprovLV.Utils.LastUpdateDateTime.styleDefaultYellow
				);
			}
		}
		return lastUpdateDate;
	};

	/**
	 * calculate lastUpdate date and render it in template
	 * @param {object} pageRaw - pageRaw data
	 * @param {object} specialContent - specialContent data
	 * @param {string} calcUpdateTimeType - calcUpdateTimeType, type how data will be calculated,
	 * 		defaultAndSpecial => use pageRaw, page default contents and special content
	 * 		onlySpecial => use only special content
	 */
	WebBaseAprovLV.Utils.LastUpdateDateTime.calcAndShow = function (pageRaw, specialContent, calcUpdateTimeType = 'defaultAndSpecial') {
		// first at all resetLastUpdateDateTime
		WebBaseAprovLV.Utils.LastUpdateDateTime.reset();

		let lastUpdateDate = '';
		let defaultLabel = {
			'prefix': {
				'de': 'Letzte Aktualisierung:',
				'it': 'Ultimo aggiornamento:',
				'en': 'Last updated:',
				'lld': 'Ultimo ajornamënt:'
			},
			'today': {
				'de': ' Heute',
				'it': ' Oggi',
				'en': ' Today',
				'lld': ' Incö'
			}
		};

		switch (calcUpdateTimeType) {
			case 'defaultAndSpecial':
				// page model
				lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, [pageRaw]);
				// default page content models
				lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, pageRaw.pageContent);
				// homepage content models
				lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, pageRaw.container);
				// default content models
				lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, pageRaw.modular_content);

				// special content models like news_homepage
				for (key in specialContent) {
					if (specialContent && specialContent[key] && specialContent[key].hasOwnProperty('raw') && specialContent[key].raw.hasOwnProperty('items')) {
						lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, specialContent[key].raw.items);
					} else if (
						specialContent
						&& specialContent[key]
						&& specialContent[key].hasOwnProperty('raw')
						&& specialContent[key].raw.hasOwnProperty('GSP')
						&& specialContent[key].raw.GSP.hasOwnProperty('RES')
					) {
						lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, specialContent[key].raw.GSP.RES['R']);
					} else {
						lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, specialContent);
					}
				}
				break;
			case 'onlySpecial':
				// special content models
				for (key in specialContent) {
					if (specialContent[key].hasOwnProperty('raw')) {
						lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, specialContent[key].raw.items);
					} else {
						lastUpdateDate = WebBaseAprovLV.Utils.LastUpdateDateTime.calc(lastUpdateDate, specialContent);
					}
				}
				break;
		};

		let lastUpdateBoxText = '';
		if (lastUpdateDate !== '') {
			let today = new Date();
			// create date obj an remove 1 hour because utc +1
			let lastUpdateDateObject = new Date(new Date(lastUpdateDate).getTime() - 60 * 60 * 1000);
			let lastUpdateDateFormatted = (today.toDateString() === lastUpdateDateObject.toDateString())
				? defaultLabel['today'][(/^(de|it|en|lld)$/.test(WebBaseAprovLV.lang) ? WebBaseAprovLV.lang : 'de')]
				: lastUpdateDateObject.toISOString().replace(/T.*/, '').split('-').reverse().join('/');

			lastUpdateBoxText = '<div class="updates"><div class="container"><div class="row"><p class="pl-2"><em>'
				+ defaultLabel['prefix'][(/^(de|it|en|lld)$/.test(WebBaseAprovLV.lang) ? WebBaseAprovLV.lang : 'de')] + ' '
				+ lastUpdateDateFormatted
				+ '</em></p></div></div></div>';
		}
		WebBaseAprovLV.Utils.LastUpdateDateTime.setDateTime(lastUpdateBoxText);
	};
})();
/* ==========
 * Shared METEO/WETTER Helpers (Dates, i18n, Merge, Map, Grouping)
 * index.js (clean & consolidated)
 * ========== */
(function () {
	'use strict';

	// Namespace
	window.WebBaseAprovLV = window.WebBaseAprovLV || {};
	const U = (WebBaseAprovLV.Utils = WebBaseAprovLV.Utils || {});

	/* ──────────────────────────────────────────────────────────────────────────
	 * Language & i18n
	 * ────────────────────────────────────────────────────────────────────────── */
	function _effLang(lang) {
		const l = (lang || WebBaseAprovLV.lang || 'de').toLowerCase();
		return l === 'lld' ? 'lld' : l;
	}
	U._effLang = U._effLang || _effLang;

	U.getLocalizedField =
		U.getLocalizedField ||
		function (obj, baseKey, lang) {
			if (!obj || !baseKey) return undefined;
			const le = _effLang(lang);
			const keys = [baseKey + '_' + le, baseKey + '_de', baseKey + '_it', baseKey + '_en', baseKey];
			for (let k of keys) {
				if (Object.prototype.hasOwnProperty.call(obj, k) && obj[k] != null && obj[k] !== '') return obj[k];
			}
			return undefined;
		};

	U.localizedSlugsForRegion = function (sel) {
		const fallback = sel && sel.url_slug;
		const de = U.getLocalizedField(sel, 'url_slug', 'de') || fallback || '';
		const it = U.getLocalizedField(sel, 'url_slug', 'it') || de || '';
		const en = U.getLocalizedField(sel, 'url_slug', 'en') || de || '';
		const lld = U.getLocalizedField(sel, 'url_slug', 'lld') || de || '';
		return { de, it, en, lld };
	};

	/* ──────────────────────────────────────────────────────────────────────────
	 * Escaping & Date / formatting
	 * ────────────────────────────────────────────────────────────────────────── */

	U.escapeHtml =
		U.escapeHtml ||
		function (str) {
			return String(str == null ? '' : str)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#39;');
		};

	U.fmtDateISOToLocale = function (isoDay, lang) {
		if (!isoDay) return '';
		const d = new Date(String(isoDay) + 'T00:00:00');
		if (isNaN(d)) return '';
		return d.toLocaleDateString(U._effLang(lang), { day: '2-digit', month: '2-digit', year: 'numeric' });
	};

	U.tabDateHtml =
		U.tabDateHtml ||
		function (value) {
			return U.escapeHtml(value).replace(/(\d{4})(?!.*\d{4})/, '<span class="meteo-tab-date-year">$1</span>');
		};

	U.fmtTabDateISOToLocaleHtml =
		U.fmtTabDateISOToLocaleHtml ||
		function (isoDay, lang) {
			return U.tabDateHtml(U.fmtDateISOToLocale(isoDay, lang));
		};

	U.fmtWeekdayISO = function (isoDay, lang) {
		if (!isoDay) return '';
		const d = new Date(String(isoDay) + 'T00:00:00');
		if (isNaN(d)) return '';
		return d.toLocaleDateString(U._effLang(lang), { weekday: 'long' });
	};

	U.fmtTime = function (t, lang) {
		if (!t) return '—';
		const L = (U._effLang ? U._effLang(lang) : (lang || 'de')).toLowerCase();
		const s = String(t).trim();
		if (L === 'de') return s + ' Uhr';
		if (L === 'it') return 'ore ' + s;
		return s;
	};

	U.todayISO = function () {
		const d = new Date();
		const m = String(d.getMonth() + 1).padStart(2, '0');
		const day = String(d.getDate()).padStart(2, '0');
		return d.getFullYear() + '-' + m + '-' + day;
	};

	U.compass =
		U.compass ||
		function (angle) {
			var windsByLang = {
				de: ['N', 'NO', 'O', 'SO', 'S', 'SW', 'W', 'NW'],
				it: ['N', 'NE', 'E', 'SE', 'S', 'SO', 'O', 'NO'],
				en: ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'],
				lld: ['N', 'NO', 'O', 'SO', 'S', 'SV', 'V', 'NW']
			};
			var lang = (WebBaseAprovLV.lang || 'de').toLowerCase();
			var winds = windsByLang[lang] || windsByLang.de;
			var a = Number(angle);
			if (!isFinite(a)) return null;
			a = ((a % 360) + 360) % 360;
			var idx = Math.floor((a + 22.5) / 45) % 8;
			return winds[idx];
		};

	U.fmtTemp = (v) => (v === 0 || (v != null && v !== '')) ? v + ' °C' : '';
	U.fmtMm = (v) => (v === 0 || (v != null && v !== '')) ? v + ' mm' : '--- mm';
	U.fmtPct = (v) => (v === 0 || (v != null && v !== '')) ? v + ' %' : '--- %';
	U.fmtMeters = (v) => (v === 0 || (v != null && v !== '')) ? v + ' m' : '---';
	U.fmtKmh = (v) => {
		if (v == null || !isFinite(v)) return '— km/h';
		return Math.round(v) + ' km/h';
	};

	/*
	 * Localized compact formatters for map/list values.
	 * Keep these separate from the legacy fmt* helpers above because those
	 * have established empty-value semantics in older templates.
	 */
	U.formatLocalizedNumber = U.formatLocalizedNumber || function (value, opts) {
		opts = opts || {};
		if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) {
			return typeof opts.empty === 'string' ? opts.empty : '—';
		}
		var digits = Number.isFinite(Number(opts.maximumFractionDigits))
			? Math.max(0, Number(opts.maximumFractionDigits))
			: 1;
		try {
			return new Intl.NumberFormat(U.localeFor(opts.lang || WebBaseAprovLV.lang), {
				maximumFractionDigits: digits
			}).format(Number(value));
		} catch (_) {
			return String(value);
		}
	};

	U.MeteoFormat = U.MeteoFormat || {
		alt: function (v, lang) {
			var n = U.formatLocalizedNumber(v, { lang: lang, maximumFractionDigits: 0 });
			return n === '—' ? n : n + ' m';
		},
		c: function (v, lang) {
			var n = U.formatLocalizedNumber(v, { lang: lang, maximumFractionDigits: 1 });
			return n === '—' ? n : n + ' °C';
		},
		mm: function (v, lang) {
			var n = U.formatLocalizedNumber(v, { lang: lang, maximumFractionDigits: 1 });
			return n === '—' ? n : n + ' mm';
		},
		p: function (v, lang) {
			var n = U.formatLocalizedNumber(v, { lang: lang, maximumFractionDigits: 0 });
			return n === '—' ? n : n + ' %';
		},
		h: function (v, lang) {
			var n = U.formatLocalizedNumber(v, { lang: lang, maximumFractionDigits: 1 });
			return n === '—' ? n : n + ' h';
		}
	};

	U.windArrowSvg = function (r, arrowAngle, color) {
		var shaftWidth = r * 0.14;  // Pfeildicke
		var shaftLen = r * 0.8;     // Schaftlänge
		var headLen = r * 0.35;     // Kopflänge
		var headWidth = r * 0.65;   // Kopfbreite
		return '' +
			'<g transform="translate(0,0) rotate(' + arrowAngle + ')">' +
			'<line x1="0" y1="' + (shaftLen / 2) + '" x2="0" y2="' + (-shaftLen / 2) + '" ' +
			' stroke="' + color + '" stroke-width="' + shaftWidth + '" stroke-linecap="round"/>' +
			'<polygon points="' +
				'0,' + (-shaftLen / 2 - headLen) + ' ' +
				(-headWidth / 2) + ',' + (-shaftLen / 2) + ' ' +
				(headWidth / 2) + ',' + (-shaftLen / 2) +
			'" fill="' + color + '"/>' +
			'</g>';
	};

	U.buildWindDirIcon = function (dirDeg, label, opts) {
		opts = opts || {};
		var size = opts.size || 8;
		var color = opts.color || '#000';
		var boldLabel = !!opts.boldLabel;
		var withDeg = (opts.withDegrees !== false);
		var emptyHtml = (typeof opts.emptyHtml === 'string') ? opts.emptyHtml : '<span class="wind-dir-empty">--</span>';
		var num = Number(dirDeg);
		if (dirDeg === null || dirDeg === undefined || !Number.isFinite(num) || !label) {
			return emptyHtml;
		}
		var arrowSvg = U.windArrowSvg(size, num + 180, color);
		var labelHtml = U.escapeHtml(label);
		if (boldLabel) {
			labelHtml = '<strong>' + labelHtml + '</strong>';
		}
		var html =
			'<span class="wind-dir-cell">' +
			'<span class="wind-arrow-svg" aria-hidden="true">' +
			'<svg width="' + (size * 2 + 2) + '" height="' + (size * 2 + 2) + '" ' +
				'viewBox="' + (-size) + ' ' + (-size) + ' ' + (size * 2) + ' ' + (size * 2) + '" ' +
				'xmlns="http://www.w3.org/2000/svg">' +
			arrowSvg +
			'</svg>' +
			'</span>' +
			'<span class="wr">' + labelHtml + '</span>' +
			'</span>';
		if (withDeg) {
			html += '<span class="sr-only">(' + num + '°)</span>';
		}
		return html;
	};


	// ─────────────────────────────────────────────────────────────
	// UI / Debounce / Throttle + Smooth Scroll Tabs
	// ─────────────────────────────────────────────────────────────

	U.ui = U.ui || {};

	U.ui.supportsHover = function () {
		try {
			return window.matchMedia('(hover: hover)').matches && !('ontouchstart' in window);
		} catch (_) {
			return !(window.L && L.Browser && L.Browser.touch);
		}
	};

	/**
	 * Aktiviert einen Day-Tab (#dayTabs / #dayTabContent) anhand ISO-Tag.
	 * Erwartet das Standardmarkup:
	 *   - Tabs:  #dayTabs a.nav-link[href="#content-day-YYYY-MM-DD"]
	 *   - Panes: #dayTabContent #content-day-YYYY-MM-DD
	 *
	 * @param {string} isoDay      z.B. "2025-11-19"
	 * @param {Object} [opts]
	 * @param {boolean} [opts.scrollIntoView]  ob der Tab in Sicht gescrollt werden soll
	 * @param {boolean} [opts.instant]         ob das Scrollen instant sein soll
	 */
	U.ui.activateDayTab = function (isoDay, opts) {
		if (!isoDay) return;
		opts = opts || {};

		try {
			var tabs = document.querySelectorAll('#dayTabs a.nav-link');
			tabs.forEach(function (a) {
			a.classList.remove('active');
			a.setAttribute('aria-selected', 'false');
			});

			var panes = document.querySelectorAll('#dayTabContent .tab-pane');
			panes.forEach(function (p) {
			p.classList.remove('show', 'active');
			});

			var link = document.querySelector('#dayTabs a[href="#content-day-' + isoDay + '"]');
			var pane = document.getElementById('content-day-' + isoDay);

			if (link) {
			link.classList.add('active');
			link.setAttribute('aria-selected', 'true');
			}
			if (pane) {
			pane.classList.add('show', 'active');
			}

			if (opts.scrollIntoView && U.ui && typeof U.ui.scrollActiveTabIntoView === 'function') {
			setTimeout(function () {
				try {
				U.ui.scrollActiveTabIntoView('dayTabs', { instant: !!opts.instant });
				} catch (_) {}
			}, 0);
			}
		} catch (_) {
		}
	};

	U.ui._debounce =
		U.ui._debounce ||
		function (fn, ms) {
			let t;
			return function (...args) {
				const ctx = this;
				clearTimeout(t);
				t = setTimeout(function () {
					fn.apply(ctx, args);
				}, ms || 120);
			};
		};

	U.debounce = U.debounce || function (fn, ms) {
		return U.ui._debounce(fn, ms);
	};

	U.throttleRAF =
		U.throttleRAF ||
		function (fn) {
			let busy = false;
			return function (...args) {
				if (busy) return;
				busy = true;
				const ctx = this;
				requestAnimationFrame(function () {
					try {
						fn.apply(ctx, args);
					} finally {
						busy = false;
					}
				});
			};
		};


	/**
	 * Ensure container scrolls so the active .nav-link is centered.
	 * @param {HTMLElement|string} containerOrId  #id or element of the tabs <ul>
	 * @param {{instant?: boolean}} [opts]
	 */
	function scrollActiveTabIntoView(containerOrId, opts) {
		const container = resolveContainer(containerOrId);
		if (!container) return;
		const active = container.querySelector('.nav-link.active');
		if (!active) return;
		centerChild(container, active, opts);
	}

	/**
	 * Ensure container scrolls so the given link is centered.
	 * @param {HTMLElement|string} containerOrId
	 * @param {HTMLElement} linkEl
	 * @param {{instant?: boolean}} [opts]
	 */
	function scrollTabIntoView(containerOrId, linkEl, opts) {
		const container = resolveContainer(containerOrId);
		if (!container || !linkEl) return;
		centerChild(container, linkEl, opts);
	}

	function resolveContainer(x) {
		if (!x) return null;
		if (typeof x === 'string') return document.getElementById(x.replace(/^#/, '')) || null;
		if (x.nodeType === 1) return x;
		return null;
	}

	function centerChild(container, el, opts) {
		if (!container || !el) return;
		const cRect = container.getBoundingClientRect();
		const eRect = el.getBoundingClientRect();

		const delta = (eRect.left + eRect.width / 2) - (cRect.left + cRect.width / 2);
		const maxScrollLeft = Math.max(0, container.scrollWidth - cRect.width);
		const next = Math.max(0, Math.min(container.scrollLeft + delta, maxScrollLeft));

		if (typeof container.scrollTo === 'function') {
			container.scrollTo({ left: next, top: 0, behavior: (opts && opts.instant) ? 'auto' : 'smooth' });
		} else {
			container.scrollLeft = next;
		}
	}

	U.ui.initStepSwipeTabs =
		U.ui.initStepSwipeTabs ||
		function (containerOrId) {
			function resolveContainer(x) {
			if (!x) return null;
			if (typeof x === 'string') return document.getElementById(x.replace(/^#/, '')) || null;
			if (x.nodeType === 1) return x;
			return null;
			}

			var container = resolveContainer(containerOrId);
			if (!container) return;

			if (container.dataset.stepSwipeInit === '1') return;
			container.dataset.stepSwipeInit = '1';

			try {
			if (U.ui.supportsHover && U.ui.supportsHover()) {
				return;
			}
			} catch (_) {}

			var startX = null;
			var startY = null;
			var startScrollLeft = 0;
			var tracking = false;

			function getLinks() {
			return container.querySelectorAll('a.nav-link');
			}

			function getActiveIndex(links) {
			var idx = 0;
			links.forEach(function (a, i) {
				if (a.classList.contains('active')) idx = i;
			});
			return idx;
			}

			function activateLink(links, index) {
			if (!links || !links.length) return;
			if (index < 0 || index >= links.length) return;

			var target = links[index];

			if (window.jQuery && jQuery.fn.tab && typeof jQuery(target).tab === 'function') {
				jQuery(target).tab('show');
			} else {
				var href = target.getAttribute('href') || '';
				var iso = href.replace('#content-day-', '');
				if (U.ui && typeof U.ui.activateDayTab === 'function') {
				U.ui.activateDayTab(iso, { scrollIntoView: false });
				}
			}

			if (U.ui && typeof U.ui.scrollTabIntoView === 'function') {
				U.ui.scrollTabIntoView(container, target, { instant: false });
			}
			}

			container.addEventListener(
			'touchstart',
			function (e) {
				if (!e.touches || e.touches.length !== 1) return;
				var t = e.touches[0];
				startX = t.clientX;
				startY = t.clientY;
				startScrollLeft = container.scrollLeft || 0;
				tracking = true;
			},
			{ passive: true }
			);

			container.addEventListener(
			'touchmove',
			function (e) {
				if (!tracking) return;
				if (!e.touches || e.touches.length !== 1) return;
				var t = e.touches[0];
				var dx = t.clientX - startX;
				var dy = t.clientY - startY;

				if (Math.abs(dx) > Math.abs(dy)) {
				e.preventDefault();

				var targetScrollLeft = startScrollLeft - dx;
				var maxScrollLeft = Math.max(0, container.scrollWidth - container.clientWidth);
				if (targetScrollLeft < 0) targetScrollLeft = 0;
				if (targetScrollLeft > maxScrollLeft) targetScrollLeft = maxScrollLeft;
				container.scrollLeft = targetScrollLeft;
				}
			},
			{ passive: false }
			);

			function endSwipe(e) {
			if (!tracking) return;
			tracking = false;
			var changed = e.changedTouches && e.changedTouches[0];
			if (!changed) return;

			var dx = changed.clientX - startX;
			var dy = changed.clientY - startY;

			if (Math.abs(dx) <= Math.abs(dy)) {
				return;
			}

			var threshold = 30; 
			if (Math.abs(dx) < threshold) {
				return;
			}

			var direction = dx < 0 ? 1 : -1; 
			var links = getLinks();
			if (!links.length) return;

			var activeIdx = getActiveIndex(links);
			var nextIdx = activeIdx + direction;

			if (nextIdx < 0 || nextIdx >= links.length) {
				return;
			}

			activateLink(links, nextIdx);
			}

			container.addEventListener('touchend', endSwipe, { passive: true });
			container.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
		};



	U.ui.scrollActiveTabIntoView = U.ui.scrollActiveTabIntoView || scrollActiveTabIntoView;
	U.ui.scrollTabIntoView = U.ui.scrollTabIntoView || scrollTabIntoView;


	// ─────────────────────────────────────────────────────────────
	// Relative Day Labels + Wetter-Überschriften (DE/IT/EN/LLD)
	// ─────────────────────────────────────────────────────────────

	const LEX = {
		de: {
			today: 'Heute',
			tomorrow: 'Morgen',
			weather_today: 'Das Wetter heute',
			weather_tomorrow: 'Das Wetter morgen',
			weather_on: 'Das Wetter am __DAY__'
		},
		it: {
			today: 'Oggi',
			tomorrow: 'Domani',
			weather_today: 'Il tempo di oggi',
			weather_tomorrow: 'Il tempo di domani',
			weather_on: 'Il tempo di __DAY__'
		},
		en: {
			today: 'Today',
			tomorrow: 'Tomorrow',
			weather_today: "Today's weather",
			weather_tomorrow: "Tomorrow's weather",
			weather_on: 'Weather on __DAY__'
		},
		lld: {
			today: 'Ncuei',
			tomorrow: 'Duman',
			weather_today: 'L tëmp ncuei',
			weather_tomorrow: 'L tëmp duman',
			weather_on: 'L tëmp __DAY__'
		}
	};

	function _todayISO() {
		return U.todayISO ? U.todayISO() : new Date().toISOString().slice(0, 10);
	}

	function _addDaysISO(iso, n) {
		try {
			const d = new Date(String(iso) + 'T00:00:00Z');
			if (isNaN(d)) return iso;
			d.setUTCDate(d.getUTCDate() + Number(n || 0));
			return d.toISOString().slice(0, 10);
		} catch (_) {
			return iso;
		}
	}

	function _isSameISO(a, b) {
		return String(a || '') === String(b || '');
	}

	U.addDaysISO = U.addDaysISO || _addDaysISO;
	U.isTodayISO =
		U.isTodayISO ||
		function (iso, nowISO) {
			return _isSameISO(iso, nowISO || _todayISO());
		};
	U.isTomorrowISO =
		U.isTomorrowISO ||
		function (iso, nowISO) {
			return _isSameISO(iso, _addDaysISO(nowISO || _todayISO(), 1));
		};

	U.localIsoDayFromUTC =
		U.localIsoDayFromUTC ||
		function (dateLike, tz) {
			if (!dateLike) return '';
			try {
				var d = new Date(dateLike);
				if (isNaN(d)) return String(dateLike).slice(0, 10);
				var timeZone =
					tz ||
					(WebBaseAprovLV.config && WebBaseAprovLV.config.defaultTimeZone) ||
					'Europe/Rome';
				var parts = new Intl.DateTimeFormat('en-CA', {
					timeZone: timeZone,
					year: 'numeric',
					month: '2-digit',
					day: '2-digit'
				}).formatToParts(d);
				var y = '', m = '', dd = '';
				for (var i = 0; i < parts.length; i++) {
					if (parts[i].type === 'year')  y  = parts[i].value;
					if (parts[i].type === 'month') m  = parts[i].value;
					if (parts[i].type === 'day')   dd = parts[i].value;
				}
				return y + '-' + m + '-' + dd;
			} catch (e) {
				return String(dateLike).slice(0, 10);
			}
		};

	U.tabDayLabel =
		U.tabDayLabel ||
		function (iso, lang) {
			const langKey = (lang || 'de').toLowerCase();
			const lex = LEX[langKey] || LEX.de;
			if (U.isTodayISO(iso)) return lex.today;
			if (U.isTomorrowISO(iso)) return lex.tomorrow;
			const base = U.fmtWeekdayISO ? U.fmtWeekdayISO(iso, lang) : iso;
			if (langKey === 'it' && base) {
			return base.charAt(0).toUpperCase() + base.slice(1);
			}
			return base;
		};

	U.weatherHeading =
		U.weatherHeading ||
		function (iso, lang) {
			const langKey = (lang || 'de').toLowerCase();
			const lex = LEX[langKey] || LEX.de;
			if (U.isTodayISO(iso)) return lex.weather_today;
			if (U.isTomorrowISO(iso)) return lex.weather_tomorrow;
			const dayLabel = U.fmtWeekdayISO ? U.fmtWeekdayISO(iso, lang) : iso;
			return (lex.weather_on || LEX.de.weather_on).replace('__DAY__', dayLabel);
		};

	U.forecastSubheading =
		U.forecastSubheading ||
		function (iso, lang) {
			const langKey = (lang || 'de').toLowerCase();
			const lex = LEX[langKey] || LEX.de;
			const weekday = U.fmtWeekdayISO ? U.fmtWeekdayISO(iso, lang) : iso;
			if (U.isTodayISO(iso))
			return lex.today.toLowerCase() + ', ' + weekday;
			if (U.isTomorrowISO(iso))
			return lex.tomorrow.toLowerCase() + ', ' + weekday;
			return weekday;
		};

	// ─────────────────────────────────────────────────────────────
	// Ladin weekday names (lld)
	// lunesc, merdi, mierculdì, juebia, vënerdì, sada, dumënia
	// ─────────────────────────────────────────────────────────────

	(function installLadinWeekdays(U) {
		if (!U) return;
		const LLD_WEEKDAYS_BY_UTCDAY = [
			'dumënia',  // 0 = Sunday
			'lunesc',    // 1 = Monday
			'merdi',     // 2 = Tuesday
			'mierculdì', // 3 = Wednesday
			'juebia',    // 4 = Thursday
			'vënerdì',  // 5 = Friday
			'sada'     // 6 = Saturday
		];
		const _origFmtWeekdayISO = U.fmtWeekdayISO;
		U.fmtWeekdayISO = function fmtWeekdayISO(iso, lang) {
			const langKey = String(lang || 'de').toLowerCase();
			if (langKey === 'lld') {
			try {
				const d = new Date(String(iso) + 'T00:00:00Z');
				if (isNaN(d)) return String(iso || '');
				return LLD_WEEKDAYS_BY_UTCDAY[d.getUTCDay()] || String(iso || '');
			} catch (_) {
				return String(iso || '');
			}
			}
			// fallback to existing implementation (or a minimal fallback)
			if (typeof _origFmtWeekdayISO === 'function') return _origFmtWeekdayISO(iso, lang);
			return String(iso || '');
		};
	})(U);


	/* ──────────────────────────────────────────────────────────────────────────
	 * URL / Query
	 * ────────────────────────────────────────────────────────────────────────── */
	U.getQueryParam = function (name, searchStr) {
		try {
			const s = searchStr || (typeof window !== 'undefined' ? window.location.search : '');
			const m = new RegExp('[?&]' + name + '=([^&#]*)').exec(s);
			return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : null;
		} catch (e) {
			return null;
		}
	};

	U.updateAreaLinksWithTl = function (selector, tl) {
		const as = document.querySelectorAll(selector || '.dropdown-menu a.dropdown-item');
		as.forEach(function (a) {
			try {
				const url = new URL(a.getAttribute('href'), window.location.origin);
				if (tl) url.searchParams.set('tl', String(tl));
				else url.searchParams.delete('tl');
				a.setAttribute('href', url.pathname + url.search + (url.hash || ''));
			} catch (_) { }
		});
	};

	/**
	 * Baut ein Mapping isoDay -> time_layout_id
	 * @param {string[]} days - Array von ISO-Daten ('YYYY-MM-DD')
	 * @param {Object} byDay  - Map isoDay -> Objekt mit id_time_layout oder anderem Key
	 * @param {string} key    - Feldname, default: 'id_time_layout'
	 */
	U.buildTimeLayoutByDay = function (days, byDay, key) {
		var m = {};
		var k = key || 'id_time_layout';
		(days || []).forEach(function (iso) {
			var e = byDay && byDay[iso];
			if (e && e[k] != null) m[iso] = String(e[k]);
		});
		return m;
	};

	/**
	 * Findet zu einer TL-ID den passenden Tag.
	 * @param {string|null} tl
	 * @param {string[]} days
	 * @param {Object} timeLayoutByDay - Map isoDay -> TL-ID
	 */
	U.resolveIsoDayFromTl = function (tl, days, timeLayoutByDay) {
		if (!tl) return null;
		var d = days || [];
		for (var i = 0; i < d.length; i++) {
			var iso = d[i];
			if (String(timeLayoutByDay[iso] || '') === String(tl)) return iso;
		}
		return null;
	};

	/* ──────────────────────────────────────────────────────────────────────────
	 * Geo / Distances
	 * ────────────────────────────────────────────────────────────────────────── */
	U.haversineKm = function (lat1, lon1, lat2, lon2) {
		const toRad = (v) => (v * Math.PI) / 180;
		const R = 6371;
		const dLat = toRad(lat2 - lat1);
		const dLon = toRad(lon2 - lon1);
		const a =
			Math.sin(dLat / 2) ** 2 +
			Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
		return 2 * R * Math.asin(Math.sqrt(a));
	};

	U.distanceKm =
		U.distanceKm ||
		function (aLat, aLon, bLat, bLon) {
			return U.haversineKm(aLat, aLon, bLat, bLon);
		};

	/* ──────────────────────────────────────────────────────────────────────────
	 * Sky Map
	 * ────────────────────────────────────────────────────────────────────────── */
	/**
	 * Build sky map: { SKY_ID: { day, night, name } }
	 * skyList: Array<{ id, svg_day, svg_night, name_* }>
	 * opt: { id, svg_day, svg_night, nameBase }
	 */
	U.buildSkyMap = function (skyList, lang, opt) {
		const o = Object.assign(
			{ id: 'id', svg_day: 'svg_day', svg_night: 'svg_night', nameBase: 'name' },
			opt || {}
		);
		const langToSuffix = (l) => {
			if (!l) return 'deu';
			const L = String(l).toLowerCase();
			if (L === 'de' || L === 'deu' || L === 'ger' || L === 'de-DE') return 'deu';
			if (L === 'it' || L === 'ita' || L === 'it-IT') return 'ita';
			if (L === 'en' || L === 'eng' || L === 'en-GB' || L === 'en-US') return 'eng';
			if (L === 'lld' || L === 'ladin' || L === 'lad') return 'lld';
			return 'deu';
		};
		const primary = langToSuffix(lang);
		const fallbackOrder = (p) => {
			const all = ['deu', 'ita', 'eng', 'lld'];
			const order = [p].concat(all.filter((x) => x !== p));
			return order;
		};
		const pickLocalizedName = (cond) => {
			try {
				const viaHelper = U.getLocalizedField(cond, o.nameBase, lang);
				if (viaHelper && String(viaHelper).trim().length) return viaHelper;
			} catch (_) { /* ignore */ }
			for (const suf of fallbackOrder(primary)) {
				const v = cond[`${o.nameBase}_${suf}`] || cond[`name_${suf}`];
				if (v && String(v).trim().length) return String(v).trim();
			}
			return (cond[o.nameBase] || cond.name || '').trim();
		};
		const map = {};
		(skyList || []).forEach((cond) => {
			if (!cond || cond[o.id] == null) return;
			const key = String(cond[o.id]).toUpperCase();
			map[key] = {
				day: cond[o.svg_day] || '',
				night: cond[o.svg_night] || '',
				name: pickLocalizedName(cond)
			};
		});
		return map;
	};

	/* ──────────────────────────────────────────────────────────────────────────
	 * Reliability modal (shared across pages)
	 * ────────────────────────────────────────────────────────────────────────── */
	U.reliabilityI18n = function (lang) {
		const L = (lang || 'de').toLowerCase();
		const t = {
			de: {
				title: 'Zuverlässigkeit',
				close: 'Schließen',
				h2: 'Wie zuverlässig ist diese Prognose?',
				p1: 'Nicht jede Wetterlage und Variable (Temperatur, Niederschlag, Wind usw.) ist gleich einfach zu prognostizieren. Die <strong>Prognose-Zuverlässigkeit</strong> sagt aus, wie groß unser Vertrauen in die gesamte Prognose ist. Sind sich die verschiedenen Wettermodelle über eine bestimmte Wetterlage „einig“, dann wird die Zuverlässigkeit als hoch eingestuft. Ist die Wetterlage dagegen nicht „stabil“, d.h. nicht gut vorhersehbar, dann wird die Zuverlässigkeit dementsprechend niederer ausfallen.',
				p2: 'Wir empfehlen den folgenden Gebrauch:',
				li1: 'Eine Zuverlässigkeit <strong>größer als 80 %</strong> wird als <strong>hoch</strong> eingestuft. Die Vorhersage kann beim Wort genommen werden, auch wenn eine Überraschung immer möglich ist.',
				li2: 'Eine Zuverlässigkeit <strong>zwischen 60 und 80 %</strong> gilt als <strong>mittel</strong>. Die Vorhersage mag als Grundlage für die Planung dienen, aber eine Alternativstrategie sollte vorbereitet werden.',
				li3: 'Eine Zuverlässigkeit <strong>von 60 %</strong> wird als <strong>tief</strong> eingestuft. Der vorhergesagte Wettertyp entspricht zwar dem wahrscheinlichsten aller möglichen Wetterszenarien, aber es empfiehlt sich nicht, sich auf diese Prognose für die Planung kritischer Aktivitäten abzustützen. Es wird empfohlen, spätere Prognosen zu konsultieren.',
				srTrigger: 'Was bedeutet Zuverlässigkeit?'
			},
			it: {
				title: 'Affidabilità',
				close: 'Chiudi',
				h2: 'Quanto affidabile è questa previsione?',
				p1: 'Non tutte le situazioni meteorologiche e la loro evoluzione sono ugualmente facili da prevedere. L’<strong>affidabilità della previsione</strong> esprime quale è la fiducia che abbiamo nella previsione nel suo complesso. Un’alta affidabilità significa che la situazione meteorologica è ben definita o, in altre parole, ben prevedibile.',
				p2: 'Raccomandiamo di interpretare in questo modo l’affidabilità che accompagna una previsione:',
				li1: 'Un’affidabilità <strong>superiore al 80%</strong> è valutata come <strong>alta</strong>. Si può fare un buon affidamento ad una simile previsione, anche se le sorprese in meteorologia sono sempre possibili.',
				li2: 'Un’affidabilità <strong>fra 60 e 80%</strong> è considerata come <strong>media</strong>. La previsione può servire da base per pianificare le proprie attività, ma delle alternative dovrebbero pure essere prese in considerazione.',
				li3: 'Un’affidabilità <strong>di 60%</strong> è classificata <strong>bassa</strong>. Il tipo di tempo previsto corrisponde allo scenario più probabile ma è sconsigliato basarsi su questa previsione per la pianificazione di attività sensibili dalle condizioni atmosferiche. Raccomandiamo di seguire le previsioni successive.',
				srTrigger: 'Cosa significa affidabilità?'
			},
			en: {
				title: 'Reliability',
				close: 'Close',
				h2: 'How reliable is this forecast?',
				p1: 'Not every weather situation and variable (temperature, precipitation, wind, etc.) is equally easy to predict. The <strong>forecast reliability</strong> indicates our degree of trust in the entire forecast. If the various weather models for certain weather conditions “agree”, the reliability can be said to be high. If however the weather is not “stable”, i.e. not so easily predictable, the reliability will be accordingly lower.',
				p2: 'We recommend the following:',
				li1: 'Reliability of <strong>greater than 80%</strong> is said to be <strong>high</strong>. The forecast can be taken at its word, even if a surprise is always possible.',
				li2: 'Reliability of <strong>between 60% and 80%</strong> is regarded as <strong>medium</strong>. The forecast may serve as a basis for planning, but an alternative strategy should be prepared.',
				li3: 'Reliability <strong>of 60%</strong> is classified as <strong>low</strong>. Although the predicted weather type corresponds to the most probable of all the possible weather scenarios, it is not advisable to rely on this forecast for planning critical activities. It is recommended to consult subsequent forecasts.',
				srTrigger: 'What does reliability mean?'
			},
			lld: {
				title: 'Afidabltà',
				close: 'Sara fora',
				h2: 'Tan inant pon pa da tenì cont de chësta previjion?',
				p1: 'Nia uni situazion meteorologica y si evoluzions (temperatura, prezipitazions, vënt y nsci inant) ne ie unfat scëmples da udëi danora. <strong>L’afidabltà dla previjion</strong> ie la crëta che pudon n generel avëi tla prognosa. Sce la situazion meteorologica ie bën defineda y n la possa udëi danora cun na cërta segurëza possen dì che l’afidabltà ie auta. Sce la situazion dl tëmp ne ie nia stabila, uel dì nia da udëi danora cun segurëza, possa l’afidabltà nce vester plu bassa.',
				p2: 'Cunsion de nterpreté a chesta maniera l’afidabltà che acumpaniea na previjion:',
				li1: 'N’afidabltà <strong>plu auta dl 80%</strong> vën rateda <strong>auta</strong>. La previjion possa unì cherduda, ënghe sce l ie for puscibl che l se porte pro surprejes.',
				li2: 'N’afidabltà <strong>danter l 60 y l 80% ie mesana.</strong> La previjion possa vester de basa per na programazion dl’ativiteies, ma l vën cunsià de pensé a strategies auternatives.',
				li3: 'N’afidabltà <strong>dl 60%</strong> vën rateda <strong>bassa.</strong> L tëmp udù danora curespuend a chël plu probabl, ma l ne ie nia da cunsië de se lascé sun chësta previjion per prugramé ativiteies critiches. N cunsiëia de consulté plu tert mo d’autra previjions.',
				srTrigger: 'Ce significhé l afidabltà?'
			}
		};
		return t[L] || t.de;
	};

	U.reliabilityModalHtml = function (lang) {
		const t = U.reliabilityI18n(lang);
		const L = (lang || 'de').toLowerCase();
		return `
		<div class="modal fade" id="reliabilityModal" data-lang="${L}" tabindex="-1" role="dialog"
			aria-labelledby="reliabilityTitle" aria-describedby="reliabilityDesc" aria-hidden="true">
			<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="reliabilityTitle">${t.h2}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="${t.close}">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" id="reliabilityDesc">
						<p>${t.p1}</p>
						<p>${t.p2}</p>
						<ul>
							<li>${t.li1}</li>
							<li>${t.li2}</li>
							<li>${t.li3}</li>
						</ul>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">${t.close}</button>
					</div>
				</div>
			</div>
		</div>`;
	};

	U.ensureReliabilityModal = function (lang, opts) {
		const L = (lang || 'de').toLowerCase();
		const force = !!(opts && opts.force);
		const existing = document.getElementById('reliabilityModal');
		if (existing && existing.getAttribute('data-lang') === L && !force) return;
		if (existing) {
			try {
				if (window.jQuery && window.jQuery(existing).hasClass('show')) window.jQuery(existing).modal('hide');
			} catch (_) { }
			if (existing.parentNode) existing.parentNode.removeChild(existing);
		}
		const wrap = document.createElement('div');
		wrap.innerHTML = U.reliabilityModalHtml(L);
		const node = wrap.firstElementChild;
		document.body.appendChild(node);
	};

	U.reliabilityTriggerHtml = function (lang, options) {
		const t = U.reliabilityI18n(lang);
		const opts = options || {};
		const sr = opts.labelSr || t.srTrigger;
		const classes = 'btn btn-link p-0 align-baseline ' + (opts.className || '');
		return `
		<button type="button" class="${classes}" data-toggle="modal" data-target="#reliabilityModal"
				aria-controls="reliabilityModal">
			<span class="fa fa-info-circle" aria-hidden="true"></span>
			<span class="sr-only">${sr}</span>
		</button>`;
	};


	/* ──────────────────────────────────────────────────────────────────────────
	 * Grouping
	 * ────────────────────────────────────────────────────────────────────────── */
	U.groupByDay = function (items, getDateIso, mapRow, lang) {
		const L = U._effLang(lang);
		const g = {};
		(items || []).forEach(function (it) {
			const iso = getDateIso ? getDateIso(it) : null;
			if (!iso) return;
			if (!g[iso]) {
				const d = new Date(iso + 'T00:00:00');
				g[iso] = {
					displayDay: d.toLocaleDateString(L, { year: 'numeric', month: 'numeric', day: 'numeric' }),
					displayWeekday: d.toLocaleDateString(L, { weekday: 'long' }),
					rows: []
				};
			}
			g[iso].rows.push(mapRow ? mapRow(it) : it);
		});
		return g;
	};

	U.groupByIsoDay = function (items, getDate, lang) {
		const by = {};
		const set = new Set();
		(items || []).forEach((it) => {
			const d = new Date(getDate(it));
			if (isNaN(d)) return;
			const iso = d.toISOString().slice(0, 10);
			if (!by[iso]) {
				by[iso] = {
					displayDay: d.toLocaleDateString(_effLang(lang) + '-IT', { year: 'numeric', month: '2-digit', day: '2-digit' }),
					displayWeekday: d.toLocaleDateString(_effLang(lang), { weekday: 'long' }),
					rows: []
				};
			}
			by[iso].rows.push(it);
			set.add(iso);
		});
		return { groupedByDay: by, days: Array.from(set).sort() };
	};

	/* ──────────────────────────────────────────────────────────────────────────
	 * Municipal helpers
	 * ────────────────────────────────────────────────────────────────────────── */
	U.localizeMunicipalRecords =
		U.localizeMunicipalRecords ||
		function (rows, lang) {
			const list = Array.isArray(rows) ? rows : [];
			const L = U._effLang ? U._effLang(lang) : lang || 'de';
			const pick = (o, base) =>
				(U.getLocalizedField ? U.getLocalizedField(o, base, L) : o[base + '_' + L] || o[base] || '');
			const slugKey = L === 'it' ? 'url_slug_it' : L === 'en' ? 'url_slug_en' : 'url_slug_de';
			return list
				.map((r) => {
					if (!r) return null;
					const id = r.id != null ? String(r.id) : null;
					const name = pick(r, 'name') || r.name_de || r.name_it || r.name_en || '';
					const url_slug = r[slugKey] || r.url_slug_de || r.url_slug_it || r.url_slug_en || '';
					return id ? Object.assign({}, r, { id, name, url_slug }) : null;
				})
				.filter(Boolean);
		};

	// Nearest venue by lat/lon (only venues present in day’s wmap are eligible)
	U.municipalNearestVenue = function (areasById, wmap, lat, lon) {
		if (!areasById || !wmap) return null;
		let best = null;
		Object.values(areasById).forEach((v) => {
			if (!wmap[String(v.id)]) return;
			const la = Number(v.lat);
			const lo = Number(v.lon);
			if (!Number.isFinite(la) || !Number.isFinite(lo)) return;
			const d = U.haversineKm(lat, lon, la, lo);
			if (!best || d < best.distanceKm) best = { venue: v, distanceKm: d };
		});
		return best;
	};

	/* ──────────────────────────────────────────────────────────────────────────
	 * Mountain helpers
	 * ────────────────────────────────────────────────────────────────────────── */
	U.localizeMountainRecord =
		U.localizeMountainRecord ||
		function (rec, lang) {
			if (!rec) return null;
			const name = U.getLocalizedField(rec, 'name', lang) || rec.name || '';
			const slug = U.getLocalizedField(rec, 'url_slug', lang) || rec.url_slug || '';
			const id = rec.id != null ? String(rec.id) : null;
			return Object.assign({}, rec, { id, name, url_slug: slug });
		};

	U.localizeMountainRecords =
		U.localizeMountainRecords ||
		function (list, lang) {
			return (Array.isArray(list) ? list : [])
				.map((r) => U.localizeMountainRecord(r, lang))
				.filter((x) => x && x.id != null);
		};

	U.buildRegionIndexes = function (regions) {
		const byId = {};
		const bySlug = {};
		const byName = {};
		(regions || []).forEach((r) => {
			if (!r) return;
			if (r.id != null) byId[String(r.id)] = r;
			if (r.url_slug) bySlug[String(r.url_slug)] = r;
			if (r.name) byName[String(r.name)] = r;
		});
		return { byId, bySlug, byName };
	};

	U.resolveRegionIdForElevation = function (ev, idx, lang) {
		if (!ev) return null;
		const cand = [ev.id_region, ev.region_id, ev.idRegion, ev.id_region_uuid, ev.region_uuid, ev.regionId]
			.map((x) => (x != null ? String(x) : null))
			.filter(Boolean);
		for (let cid of cand) {
			if (idx.byId[cid]) return cid;
		}
		const slug = U.getLocalizedField(ev, 'region_url_slug', lang) || ev.url_slug;
		if (slug && idx.bySlug[slug]) return String(idx.bySlug[slug].id);
		const name = U.getLocalizedField(ev, 'region_name', lang) || ev.name;
		if (name && idx.byName[name]) return String(idx.byName[name].id);
		return null;
	};

	U.pickPreferredElevationForRegion = function (elevations, regionId, resolver) {
		const list = (elevations || []).filter((ev) => String(resolver(ev) || '') === String(regionId || ''));
		if (!list.length) return null;
		const pref = [2000, 2500, 1500, 3000];
		for (let p of pref) {
			const hit = list.find((ev) => Number(ev.elevation) === p);
			if (hit) return hit;
		}
		const target = 2000;
		return list
			.slice()
			.sort((a, b) => {
				const da = Math.abs((a.elevation || 0) - target);
				const db = Math.abs((b.elevation || 0) - target);
				return da !== db ? da - db : (a.name || '').localeCompare(b.name || '');
			})[0];
	};

	U.mergeMountainBulletins = function (publications, elevById, regionIdx, lang) {
		const out = [];
		(publications || [])
			.map((r) => (Array.isArray(r) ? r[0] : r))
			.filter((r) => r && r.data && Array.isArray(r.data.bulletins))
			.forEach((pub) => {
				(pub.data.bulletins || []).forEach((b) => {
					const enriched = (b.mountainsMetrics || []).map((m) => {
						const v = elevById[String(m.venueId || '')] || null;
						const rid = v ? U.resolveRegionIdForElevation(v, regionIdx, lang) : null;
						const reg = rid ? regionIdx.byId[String(rid)] || null : null;
						const vName = v ? v.name || U.getLocalizedField(v, 'name', lang) || null : null;
						const vSlug = v ? v.url_slug || U.getLocalizedField(v, 'url_slug', lang) || null : null;
						const vLat = v && v.lat != null ? v.lat : reg && reg.lat != null ? reg.lat : null;
						const vLon = v && v.lon != null ? v.lon : reg && reg.lon != null ? reg.lon : null;
						return Object.assign({}, m, {
							venueName: vName,
							venueSlug: vSlug,
							venueLat: vLat,
							venueLon: vLon,
							venueElevation: v && v.elevation != null ? v.elevation : null,
							venueRegionId: rid,
							venueRegionName: reg ? reg.name : null,
							venueRegionSlug: reg ? reg.url_slug : null,
							venueMeta: v,
							venueRegionMeta: reg
						});
					});
					out.push(Object.assign({}, b, { meta: pub.meta || {}, mountainsMetrics: enriched }));
				});
			});
		return out;
	};

	/* ──────────────────────────────────────────────────────────────────────────
	* Map (Leaflet) — hardened / performance tuned
	* ────────────────────────────────────────────────────────────────────────── */
	(function () {
		var U = (window.WebBaseAprovLV && window.WebBaseAprovLV.Utils) || window.U || (window.U = {});
		U.map = U.map || {};

		const _maps = new Map();
		const _jsonCache = new Map();

		function _normalizeCenter(center) {
			const FALLBACK = [46.642989, 11.429204];
			if (!Array.isArray(center) || center.length < 2) return FALLBACK;
			const lat = Number(center[0]);
			const lon = Number(center[1]);
			return Number.isFinite(lat) && Number.isFinite(lon) ? [lat, lon] : FALLBACK;
		}
		function _normalizeZoom(zoom) {
			if (Number.isFinite(Number(zoom))) return Number(zoom);
			return typeof window !== 'undefined' && window.innerWidth >= 768 ? 9 : 7.5;
		}
		function _snapZoom(z, snap) {
			const s = Number(snap) || 0.25;
			return Math.round(Number(z) / s) * s;
		}

		(function setupLeafletLoader() {
			const _loadedCss = new Set();
			const _scriptPromises = new Map();

			function _toAbsUrl(url) {
				try {
					return new URL(url, document.baseURI).href;
				} catch (_) {
					return url || '';
				}
			}

			function injectCssOnce(href, attrs) {
				if (!href) return;
				const abs = _toAbsUrl(href);
				if (document.querySelector('link[rel="stylesheet"][href="' + abs + '"]')) return;
				if (_loadedCss.has(abs)) return;
				const l = document.createElement('link');
				l.rel = 'stylesheet';
				l.href = abs;
				if (attrs) Object.keys(attrs).forEach((k) => l.setAttribute(k, attrs[k]));
				document.head.appendChild(l);
				_loadedCss.add(abs);
			}

			function injectJsOnce(src, attrs) {
				if (!src) return Promise.resolve();
				const abs = _toAbsUrl(src);
				if (_scriptPromises.has(abs)) return _scriptPromises.get(abs);
				const existing = Array.from(document.scripts || []).find((s) => (s.src || '') === abs);
				const promise = new Promise((resolve, reject) => {
					let timeoutId;
					const done = (ok, err) => {
						if (timeoutId) clearTimeout(timeoutId);
						Promise.resolve().then(() => (ok ? resolve() : reject(err)));
					};
					timeoutId = setTimeout(() => {
						done(false, new Error('Timeout while loading: ' + abs));
					}, 20000);
					if (existing) {
						if (existing.dataset.loaded === '1' || existing.readyState === 'complete') {
							return done(true);
						}
						existing.addEventListener(
							'load',
							() => {
								existing.dataset.loaded = '1';
								done(true);
							},
							{ once: true }
						);
						existing.addEventListener(
							'error',
							() => done(false, new Error('Failed to load: ' + abs)),
							{ once: true }
						);
						return;
					}
					const s = document.createElement('script');
					s.src = abs;
					s.async = true;
					if (attrs) Object.keys(attrs).forEach((k) => s.setAttribute(k, attrs[k]));
					s.addEventListener(
						'load',
						() => {
							s.dataset.loaded = '1';
							done(true);
						},
						{ once: true }
					);
					s.addEventListener(
						'error',
						() => done(false, new Error('Failed to load: ' + abs)),
						{ once: true }
					);
					document.head.appendChild(s);
				});
				_scriptPromises.set(abs, promise);
				return promise;
			}

			function hasLeaflet() {
				return !!(window.L && typeof L.map === 'function');
			}
			function hasGesture() {
				return !!(window.L && L.Map && (L.Map.prototype && L.Map.prototype.gestureHandling || L.GestureHandling));
			}
			function hasCluster() {
				return !!(window.L && (typeof L.markerClusterGroup === 'function' || typeof L.MarkerClusterGroup === 'function'));
			}
			function hasWms() {
				return !!(window.L && (L.tileLayer && typeof L.tileLayer.wms === 'function' || L.WMS));
			}
			function hasMeteoComponents() {
				return !!(window.customElements && window.customElements.get && window.customElements.get('weather-legend'));
			}

			function ensureCss(src, wantCluster) {
				injectCssOnce(src.leafletCSS);
				injectCssOnce(src.gestureCSS);
				if (wantCluster) {
					injectCssOnce(src.clusterCSS);
					injectCssOnce(src.clusterCSSDefault);
				}
			}

			if (typeof U.map.__isLoading === 'undefined') U.map.__isLoading = false;
			if (typeof U.map.__isReady === 'undefined') U.map.__isReady = false;
			U.map.__queue = U.map.__queue || [];

			U.map.loadLeafletAsync = function (opts) {
				opts = opts || {};
				const src = Object.assign(
					{
						leafletJS: '/js-modules/leaflet/leaflet.min.js',
						leafletCSS: '/css/leaflet/leaflet.min.css',
						gestureJS: '/js-modules/leaflet/leaflet-gesture-handling.min.js',
						gestureCSS: '/css/leaflet/leaflet-gesture-handling.min.css',
						wmsJS: '/js-modules/leaflet/leaflet.wms.min.js',
						clusterJS: '/js-modules/leaflet/leaflet.markercluster.min.js',
						clusterCSS: '/css/leaflet/leaflet-markerCluster.css',
						clusterCSSDefault: '/css/leaflet/leaflet-markercluster.default.css',
						meteoComponentsJS: '/js-modules/leaflet/meteo-components.umd.js'
					},
					opts.sources || {}
				);

				const wantCluster = !!opts.useMarkerCluster || !!(window.meteoMapConfig && window.meteoMapConfig.loadMarkerCluster);
				const wantWms = !!opts.useWms;

				ensureCss(src, wantCluster);

				function loadMissingPlugins() {
					const tasks = [];
					if (!hasGesture()) tasks.push(injectJsOnce(src.gestureJS, src.gestureAttrs));
					if (wantWms && !hasWms() && src.wmsJS) tasks.push(injectJsOnce(src.wmsJS, src.wmsAttrs));
					if (wantCluster && !hasCluster()) tasks.push(injectJsOnce(src.clusterJS, src.clusterAttrs));
					if (!hasMeteoComponents()) tasks.push(injectJsOnce(src.meteoComponentsJS, src.meteoAttrs));

					return Promise.all(tasks).then(() => {
						if (wantCluster && !hasCluster()) {
							const err = new Error('[leaflet loader] markercluster missing after load – check path/version');
							console.error(err.message);
							throw err;
						}
					});
				}

				const readyPromise = (function () {
					if (hasLeaflet()) {
						return loadMissingPlugins();
					}

					if (U.map.__isReady) {
						return loadMissingPlugins();
					}

					if (U.map.__isLoading) {
						return new Promise((resolve, reject) => {
							U.map.__queue.push(() => {
								loadMissingPlugins().then(resolve).catch(reject);
							});
						});
					}

					U.map.__isLoading = true;
					return injectJsOnce(src.leafletJS)
						.then(() => loadMissingPlugins())
						.then(() => {
							U.map.__isReady = true;
							U.map.__isLoading = false;
							try {
								const q = U.map.__queue.splice(0);
								for (let i = 0; i < q.length; i++) {
									try {
										q[i]();
									} catch (e) {
										console.error(e);
									}
								}
							} catch (_) { }
						})
						.catch((err) => {
							U.map.__isLoading = false;
							console.error('[leaflet loader] Error:', err);
							throw err;
						});
				})();

				return readyPromise
					.then(() => {
						if (typeof window.onLeafletJsLoaded === 'function') {
							try {
								window.onLeafletJsLoaded();
							} catch (_) { }
						}
						if (typeof opts.onReady === 'function') {
							try {
								opts.onReady();
							} catch (e) {
								console.error(e);
							}
						}
					})
					.catch((err) => {
						if (typeof opts.onError === 'function') {
							try {
								opts.onError(err);
							} catch (_) { }
						}
						return Promise.reject(err);
					});
			};
		})();

		U.map.waitForVisible = U.map.waitForVisible || function (elId, cb, tries) {
			tries = tries || 0;
			const el = document.getElementById(elId);
			if (!el) return;
			const ok = el.offsetWidth > 0 && el.offsetHeight > 0;
			if (ok) {
				cb && cb(el);
				return;
			}
			if (tries > 90) {
				console.warn('[map.waitForVisible] timed out for #' + elId);
				return;
			}
			requestAnimationFrame(() => U.map.waitForVisible(elId, cb, tries + 1));
		};

		U.map.create = function (elId, center, zoom) {
			const el = document.getElementById(elId);
			if (!el) throw new Error('Missing map container #' + elId);
			if (el.classList.contains('leaflet-container')) U.map.destroy(elId);

			const c = _normalizeCenter(center);
			const z = _normalizeZoom(zoom);
			const snappedZ = _snapZoom(z, 0.25);
			const isMobileLike = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

			const map = L.map(elId, {
				gestureHandling: true,
				minZoom: 7.5,
				maxZoom: 14,
				zoomSnap: 0.25,
				zoomDelta: 0.5,
				wheelPxPerZoomLevel: isMobileLike ? 80 : 120,
				touchZoom: true,
				attributionControl: false,
				zoomControl: false
			});
			map.setView(c, snappedZ);

			L.tileLayer(
				'https://geoservices.buergernetz.bz.it/mapproxy/p_bz-BaseMap/wmts/Basemap-Meteo-Bright/EPSG_3857/{z}/{x}/{y}.jpeg',
				{
					attribution: '© Autonome Provinz Bozen – GeoServices',
					updateWhenIdle: true,
					updateWhenZooming: false,
					detectRetina: true
				}
			).addTo(map);

			map.__regionsLayer = L.layerGroup().addTo(map);
			map._markersLayer = L.layerGroup().addTo(map);

			map.__initial = { center: c.slice(), zoom: snappedZ };

			const safeInvalidate = function () {
				try {
					map.invalidateSize({ animate: false });
				} catch (e) { }
			};
			const debouncedInvalidate = (() => {
				let raf = null;
				return () => {
					if (raf) cancelAnimationFrame(raf);
					raf = requestAnimationFrame(() => safeInvalidate());
				};
			})();

			debouncedInvalidate();
			setTimeout(debouncedInvalidate, 150);

			try {
				const ro = new ResizeObserver(() => debouncedInvalidate());
				ro.observe(el);
				map.__ro = ro;
			} catch (e) { }

			const onPageShow = debouncedInvalidate;
			window.addEventListener('pageshow', onPageShow);
			map.__docListeners = map.__docListeners || [];
			map.__docListeners.push([window, 'pageshow', onPageShow]);

			if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
				document.fonts.ready.then(() => debouncedInvalidate()).catch(() => { });
			}

			_maps.set(elId, map);
			return map;
		};

		U.map.get = function (elId) {
			return _maps.get(elId) || null;
		};

		U.map.ensure =
			U.map.ensure ||
			function (elId, opts, afterCreate) {
				const existing = U.map.get(elId);
				if (existing) {
					try {
						existing.invalidateSize();
					} catch (_) { }
					if (typeof afterCreate === 'function') afterCreate(existing);
					return existing;
				}
				U.map.waitForVisible(elId, function () {
					const map = U.map.create(elId, opts && opts.center, opts && opts.zoom);
					if (typeof afterCreate === 'function') afterCreate(map);
				});
			};

		U.map.ensureAndWire =
			U.map.ensureAndWire ||
			function (elId, afterCreate) {
				return U.map.ensure(elId, null, function (map) {
					try {
						map.getContainer().classList.add('lv-leaflet--raise-controls');
					} catch (e) { }
					if (typeof afterCreate === 'function') afterCreate(map);
					try {
						map.invalidateSize();
					} catch (_) { }
				});
			};

		U.map.destroy = function (elId) {
			const el = document.getElementById(elId);
			const m = U.map.get(elId);
			if (m) {
				try {
					m.__regionsAbort && m.__regionsAbort.abort();
				} catch (_) { }

				try {
					(m.__docListeners || []).forEach(([target, type, fn]) => target.removeEventListener(type, fn));
				} catch (_) { }
				m.__docListeners = [];

				try {
					m.__ro && m.__ro.disconnect();
					m.__ro = null;
				} catch (_) { }
				try {
					m.off();
				} catch (_) { }
				try {
					if (m.dragging) m.dragging.disable();
				} catch (_) { }
				try {
					if (m.boxZoom) m.boxZoom.disable();
				} catch (_) { }
				try {
					if (m.touchZoom) m.touchZoom.disable();
				} catch (_) { }
				try {
					if (m.doubleClickZoom) m.doubleClickZoom.disable();
				} catch (_) { }
				try {
					if (m.scrollWheelZoom) m.scrollWheelZoom.disable();
				} catch (_) { }
				try {
					if (m.keyboard) m.keyboard.disable();
				} catch (_) { }
				try {
					if (m._markersLayer) m._markersLayer.clearLayers();
				} catch (_) { }
				try {
					if (m.__regionsLayer) m.__regionsLayer.clearLayers();
				} catch (_) { }
				try {
					m.remove();
				} catch (_) { }
			}
			_maps.delete(elId);
			if (el) {
				el.classList.remove('leaflet-container');
				el.innerHTML = '';
			}
		};

		U.map.clearMarkers = function (map) {
			if (map && map._markersLayer) map._markersLayer.clearLayers();
		};

		U.map.addMarker = function (map, lat, lon, iconHtml, tooltip, popupHtml, options) {
			if (!map || map._markersLayer == null) return null;

			options = options || {};
			var w = Number(options.iconWidth != null ? options.iconWidth : 60);
			var h = Number(options.iconHeight != null ? options.iconHeight : 80);
			var ax = Number(options.anchorX != null ? options.anchorX : 30);
			var ay = Number(options.anchorY != null ? options.anchorY : 40);

			var iconOpts = {
				html: iconHtml || '',
				className: 'myshadow',
				iconSize: [w, h],
				iconAnchor: [ax, ay]
			};
			if (options.popupAnchor) iconOpts.popupAnchor = options.popupAnchor;
			if (options.tooltipAnchor) iconOpts.tooltipAnchor = options.tooltipAnchor;

			var icon = L.divIcon(iconOpts);
			var mk = L.marker([lat, lon], { icon: icon }).addTo(map._markersLayer);

			if (tooltip) {
				var ttOpts = { direction: 'top', sticky: true, opacity: 0.9, className: 'meteo-mini-tooltip' };
				if (options.tooltipOffset) ttOpts.offset = options.tooltipOffset;
				mk.bindTooltip(tooltip, ttOpts);
			}
			if (popupHtml) {
				var puOpts = { autoPan: true, closeButton: true, maxWidth: 340 };
				if (options.popupOffset) puOpts.offset = options.popupOffset;
				mk.bindPopup(popupHtml, puOpts);
			}
			return mk;
		};

		const NORMAL_STYLE = { color: 'black', weight: 2, fillColor: 'black', fillOpacity: 0, opacity: 0.35 };
		const SELECT_STYLE = { color: 'black', weight: 2, fillColor: 'black', fillOpacity: 0.4, opacity: 1 };

		U.setActiveRegion = function (map, regionId) {
			if (!map || !regionId) return;
			const layer = map.__regionsLayer;
			map.__activeRegionId = String(regionId);
			if (!layer || !layer.eachLayer) return;
			try {
				layer.eachLayer((l) => {
					const feat = l.feature || null;
					const fid = String(((feat && feat.properties && feat.properties.id) || ''));
					if (!fid) {
						l.setStyle && l.setStyle(NORMAL_STYLE);
						return;
					}
					if (fid === map.__activeRegionId) {
						l.setStyle && l.setStyle(SELECT_STYLE);
						try {
							l.bringToFront && l.bringToFront();
						} catch (_) { }
					} else {
						l.setStyle && l.setStyle(NORMAL_STYLE);
					}
				});
			} catch (e) {
				console.warn('[map.setActiveRegion] styling failed:', e);
			}
		};

		U.setRegionsGeoJsonOnce = function (map, url, filterFn, onClick) {
			if (!map) return Promise.reject(new Error('map missing'));
			if (map.__regionsOncePromise) return map.__regionsOncePromise;

			const cached = _jsonCache.get(url);
			const doLoad = cached
				? Promise.resolve(cached)
				: (function () {
					const ac = new AbortController();
					map.__regionsAbort = ac;
					return fetch(url, { signal: ac.signal, mode: 'cors', credentials: 'omit' })
						.then((r) => r.json())
						.then((j) => {
							_jsonCache.set(url, j);
							return j;
						});
				})();

			map.__regionsOncePromise = doLoad
				.then((json) => {
					const feats = (json && json.features) || [];
					const filtered = filterFn ? feats.filter(filterFn) : feats;
					const geo = L.geoJSON(
						{ type: 'FeatureCollection', features: filtered },
						{
							style: NORMAL_STYLE,
							onEachFeature: function (feature, layer) {
								const props = feature && feature.properties;
								const name = (props && (props.name || props.denominazione)) || '';
								if (name) {
									layer.bindTooltip(name, {
										direction: 'top',
										sticky: true,
										opacity: 0.9,
										className: 'meteo-mini-tooltip'
									});
								}
								layer.on('mouseover', () => layer.setStyle && layer.setStyle(SELECT_STYLE));
								layer.on('mouseout', () => {
									const fid = String((feature && feature.properties && feature.properties.id) || '');
									if (fid && map.__activeRegionId && fid === String(map.__activeRegionId)) {
										layer.setStyle && layer.setStyle(SELECT_STYLE);
									} else {
										layer.setStyle && layer.setStyle(NORMAL_STYLE);
									}
								});
								if (typeof onClick === 'function') layer.on('click', () => onClick(feature));
							}
						}
					);
					geo.addTo(map.__regionsLayer);
					return geo;
				})
				.catch((e) => {
					if (e && e.name === 'AbortError') return;
					console.error('[map.setRegionsGeoJsonOnce] failed:', e);
				});

			return map.__regionsOncePromise;
		};

		U.map.thresholdForZoom = function (map) {
			if (!map) return 999;
			return Math.max(0, 12.5 - map.getZoom());
		};

		U.map.resetView = function (map) {
			if (!map || !map.__initial) return;
			const initial = map.__initial;
			const center = initial.center;
			const zoom = initial.zoom;
			const bounds = initial.bounds;
			try {
				if (bounds && bounds.isValid && bounds.isValid()) {
					map.fitBounds(bounds, { animate: true });
				} else if (center && zoom != null) {
					map.setView(center, zoom, { animate: true });
				}
				setTimeout(() => {
					try {
						map.invalidateSize();
					} catch (_) { }
				}, 0);
			} catch (_) { }
		};

		U.map.setInitialBounds = function (map, bounds) {
			if (!map || !bounds) return;
			map.__initial = map.__initial || {};
			map.__initial.bounds = L.latLngBounds(bounds);
		};

		U.map.addNavigationControls = function (map, opts) {
			if (!map) return;
			opts = opts || {};
			const position = opts.position || map.__controlsPosition || 'bottomright';
			const lang =
				opts.lang ||
				(window.WebBaseAprovLV && WebBaseAprovLV.lang) ||
				document.documentElement.lang ||
				'de';
			const doc = document;
			const fsEl = () => doc.fullscreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement;
			const reqFS = (el) =>
				(el.requestFullscreen || el.webkitRequestFullscreen || el.msRequestFullscreen || function () { }).call(el);
			const exitFS = () =>
				(doc.exitFullscreen || doc.webkitExitFullscreen || doc.msExitFullscreen || function () { }).call(doc);

			const Ctl = L.Control.extend({
				options: { position },
				onAdd: function () {
					const wrap = L.DomUtil.create('div');
					const nav = document.createElement('meteo-navigation');
					map.__navEl = nav;

					if (typeof opts.mobileWidth === 'number') nav.setAttribute('mobile-width', String(opts.mobileWidth));
					nav.setAttribute('lang', lang);
					if (opts.enableKeyboard === false) nav.enableKeyboard = false;

					nav.addEventListener('zoom-in', () => {
						try {
							map.zoomIn();
						} catch (_) { }
					});
					nav.addEventListener('zoom-out', () => {
						try {
							map.zoomOut();
						} catch (_) { }
					});
					nav.addEventListener('reset-extent', () => {
						try {
							U.map.resetView(map);
						} catch (_) { }
					});
					nav.addEventListener('toggle-fullscreen', () => {
						const container = map.getContainer();
						if (!fsEl()) reqFS(container);
						else exitFS();
						setTimeout(() => {
							nav.isFullscreen = !!fsEl();
						}, 50);
						try {
							setTimeout(() => map.invalidateSize(), 80);
						} catch (_) { }
					});
					nav.addEventListener('gps-center', () => {
						if (!('geolocation' in navigator) || (location.protocol !== 'https:' && location.hostname !== 'localhost')) {
							return;
						}
						nav.isGPSActive = true;
						navigator.geolocation.getCurrentPosition(
							(pos) => {
								nav.isGPSActive = false;
								const lat = pos.coords.latitude;
								const lon = pos.coords.longitude;
								try {
									map.flyTo([lat, lon], Math.max(map.getZoom(), 12), { duration: 0.6 });
								} catch (_) { }
								if (typeof opts.onPosition === 'function') {
									try {
										opts.onPosition({ lat, lon, accuracy: pos.coords.accuracy });
									} catch (_) { }
								}
							},
							() => {
								nav.isGPSActive = false;
							},
							{ enableHighAccuracy: true, timeout: 8000, maximumAge: 0 }
						);
					});
					L.DomEvent.disableClickPropagation(wrap);
					L.DomEvent.disableScrollPropagation(wrap);
					wrap.appendChild(nav);
					return wrap;
				}
			});
			map.addControl(new Ctl());

			const onFsChange = () => {
				try {
					const nav = map.__navEl;
					if (nav) {
						nav.isFullscreen = !!(
							doc.fullscreenElement ||
							doc.webkitFullscreenElement ||
							doc.msFullscreenElement
						);
					}
					setTimeout(() => {
						try {
							map.invalidateSize();
						} catch (_) { }
					}, 60);
				} catch (_) { }
			};

			['fullscreenchange', 'webkitfullscreenchange', 'msfullscreenchange'].forEach((evt) => {
				doc.addEventListener(evt, onFsChange);
				map.__docListeners = map.__docListeners || [];
				map.__docListeners.push([doc, evt, onFsChange]);
			});
		};
	})();


	/* ──────────────────────────────────────────────────────────────────────────
	 * Misc routing helpers
	 * ────────────────────────────────────────────────────────────────────────── */
	U.getAlternateMeteoStationRouting = function (pageOrGroup) {
		const mapping = {
			valley: {
				pages: ['wetterstationen-tal', 'stazioni-meteo-valle', 'stazions-temp-valedes', 'weather-stations-valley'],
				routes: {
					de: 'wetterstationen-tal',
					it: 'stazioni-meteo-valle',
					lld: 'stazions-temp-valedes',
					en: 'weather-stations-valley'
				}
			},
			mountain: {
				pages: ['wetterstationen-berg', 'stazioni-meteo-montagna', 'stazions-temp-mont', 'weather-stations-mountain'],
				routes: {
					de: 'wetterstationen-berg',
					it: 'stazioni-meteo-montagna',
					lld: 'stazions-temp-mont',
					en: 'weather-stations-mountain'
				}
			},
			watercourse: {
				pages: ['pegelstationen', 'stazioni-idrometriche', 'stazions-ega', 'gauging-stations'],
				routes: {
					de: 'pegelstationen',
					it: 'stazioni-idrometriche',
					lld: 'stazions-ega',
					en: 'gauging-stations'
				}
			}
		};
		if (mapping[pageOrGroup]) return mapping[pageOrGroup].routes;
		for (let grp in mapping) {
			if (mapping[grp].pages.indexOf(pageOrGroup) !== -1) return mapping[grp].routes;
		}
		return { de: '', it: '', lld: '', en: '' };
	};

	U.getAlternateSouthTyrolWeatherRouting = function (pageOrGroup) {
		const mapping = {
			southtyrol: {
				pages: ['suedtirolwetter', 'meteo-alto-adige', 'meteo-suedtirol', 'south-tyrol-weather'],
				routes: {
					de: 'suedtirolwetter',
					it: 'meteo-alto-adige',
					lld: 'meteo-suedtirol',
					en: 'south-tyrol-weather'
				}
			},
			municipal: {
				pages: ['gemeindewetter', 'meteo-comuni', 'temp-chemuns', 'municipality-weather'],
				routes: {
					de: 'gemeindewetter',
					it: 'meteo-comuni',
					lld: 'temp-chemuns',
					en: 'municipality-weather'
				}
			}
		};
		if (mapping[pageOrGroup]) return mapping[pageOrGroup].routes;
		for (let grp in mapping) {
			if (mapping[grp].pages.indexOf(pageOrGroup) !== -1) return mapping[grp].routes;
		}
		return { de: '', it: '', lld: '', en: '' };
	};

	U.updateManifestForLang = function (lang) {
		var map = {
			de: 'fav/site.webmanifest',
			it: 'fav/site.it.webmanifest',
			en: 'fav/site.en.webmanifest',
			lld: 'fav/site.lld.webmanifest'
		};
		var href = map[lang] || map.de;
		var link = document.querySelector('link[rel="manifest"]');
		if (!link) {
			link = document.createElement('link');
			link.setAttribute('rel', 'manifest');
			link.id = 'app-manifest';
			document.head.appendChild(link);
		}
		link.setAttribute('href', href);
	};

	/* ──────────────────────────────────────────────────────────────────────────
	 * Misc timestamp helpers
	 * ────────────────────────────────────────────────────────────────────────── */
	function el(tag, cls, html) {
		var e = document.createElement(tag);
		if (cls) e.className = cls;
		if (html != null) e.innerHTML = html;
		return e;
	}

	/**
	 * @param {HTMLElement} container
	 * @param {string|Date} isoOrDate - ISO mit Z bevorzugt
	 */
	U.renderInlineTimestamp = function (container, isoOrDate) {
		if (!container) return;
		var d = (isoOrDate instanceof Date) ? isoOrDate : new Date(isoOrDate);
		var issuedISO = isNaN(d.getTime()) ? '' : d.toISOString();
		var issuedText = (U.formatDateTime && typeof U.formatDateTime === 'function')
			? U.formatDateTime(d, 'withtime')
			: d.toLocaleString();
		var wrap = el('div', 'text-muted small d-inline-flex');
		var icon = el('i', 'fa fa-clock-o mr-2');
		icon.setAttribute('aria-hidden', 'true');
		var sr = el('span', 'sr-only', U.gettext('Last update time') + ':');
		var span = el('span', null);
		span.appendChild(document.createTextNode(U.gettext('Updated on') + ': '));
		if (issuedISO) {
			var time = el('time');
			time.setAttribute('datetime', issuedISO);
			var strong = el('strong', null, issuedText);
			time.appendChild(strong);
			span.appendChild(time);
		} else {
			span.appendChild(el('strong', null, '—'));
		}
		wrap.appendChild(icon);
		wrap.appendChild(sr);
		wrap.appendChild(span);
		container.innerHTML = '';
		container.appendChild(wrap);
	};

	/* ──────────────────────────────────────────────────────────────────────────
	 * Favorite Store (generic)
	 * ────────────────────────────────────────────────────────────────────────── */
	U.createFavStore = function (key, opts) {
		opts = opts || {};
		const eventName = opts.eventName || (key + 'change');
		const globalName = opts.globalName || null;

		const Store = {
			key: key,
			eventName: eventName,
			_cache: null,
			_read() {
				try {
					const raw = JSON.parse(localStorage.getItem(key) || '[]');
					return new Set((raw || []).map(String));
				} catch (_) {
					return new Set();
				}
			},
			get() {
				return this._cache || (this._cache = this._read());
			},
			refresh() {
				this._cache = this._read();
				return this._cache;
			},
			set(set) {
				const arr = Array.from(set || []);
				try {
					localStorage.setItem(key, JSON.stringify(arr));
				} catch (_) { }
				this._cache = new Set(arr);
				return this._cache;
			},
			has(id) {
				return this.get().has(String(id));
			},
			toggle(id) {
				const sId = String(id);
				const set = this.get();
				const active = set.has(sId) ? (set.delete(sId), false) : (set.add(sId), true);
				this.set(set);
				try {
					window.dispatchEvent(
						new CustomEvent(eventName, {
							detail: { id: sId, active, set: this._cache }
						})
					);
				} catch (_) { }
				return active;
			},
			clear() {
				this.set(new Set());
				try {
					window.dispatchEvent(
						new CustomEvent(eventName, {
							detail: { id: null, active: false, set: this._cache, cleared: true }
						})
					);
				} catch (_) { }
				return this._cache;
			}
		};

		if (globalName && !window[globalName]) {
			window[globalName] = Store;
		}

		window.addEventListener('storage', function (ev) {
			if (ev.key === key) {
				Store.refresh();
				try {
					window.dispatchEvent(
						new CustomEvent(eventName, {
							detail: { id: null, active: null, set: Store._cache }
						})
					);
				} catch (_) { }
			}
		});

		return Store;
	};


	/* ──────────────────────────────────────────────────────────────────────────
	 * Preference Store (scalar localStorage values)
	 * Same cache/event pattern as createFavStore, but for a single setting value.
	 * ────────────────────────────────────────────────────────────────────────── */
	U.createPreferenceStore = U.createPreferenceStore || function (key, opts) {
		opts = opts || {};
		const eventName = opts.eventName || (key + 'change');
		const globalName = opts.globalName || null;
		const defaultValue = (typeof opts.defaultValue !== 'undefined') ? opts.defaultValue : null;
		const normalize = (typeof opts.normalize === 'function') ? opts.normalize : function (value) { return value; };

		const Store = {
			key: key,
			eventName: eventName,
			_cache: undefined,
			_read() {
				try {
					const raw = localStorage.getItem(key);
					return normalize(raw === null ? defaultValue : raw);
				} catch (_) {
					return normalize(defaultValue);
				}
			},
			get() {
				if (typeof this._cache === 'undefined') this._cache = this._read();
				return this._cache;
			},
			refresh() {
				this._cache = this._read();
				return this._cache;
			},
			set(value) {
				const normalized = normalize(value);
				try {
					localStorage.setItem(key, String(normalized));
				} catch (_) { }
				this._cache = normalized;
				try {
					window.dispatchEvent(
						new CustomEvent(eventName, {
							detail: { value: normalized }
						})
					);
				} catch (_) { }
				return normalized;
			}
		};

		if (globalName && !window[globalName]) {
			window[globalName] = Store;
		}

		window.addEventListener('storage', function (ev) {
			if (ev.key !== key) return;
			Store.refresh();
			try {
				window.dispatchEvent(
					new CustomEvent(eventName, {
						detail: { value: Store._cache }
					})
				);
			} catch (_) { }
		});

		return Store;
	};

	U.WeatherViewMode = U.WeatherViewMode || {
		SIMPLE: 'simple',
		TABS: 'tabs'
	};

	U.WeatherViewModeStore = U.WeatherViewModeStore || U.createPreferenceStore('southtyrolWeatherViewMode', {
		eventName: 'southtyrolweatherviewmodechange',
		globalName: 'SouthTyrolWeatherViewModeStore',
		defaultValue: U.WeatherViewMode.TABS,
		normalize: function (value) {
			return value === U.WeatherViewMode.SIMPLE ? U.WeatherViewMode.SIMPLE : U.WeatherViewMode.TABS;
		}
	});

	U.FavStoreWebcam = U.FavStoreWebcam || U.createFavStore('favCams', {
		eventName: 'favcamchange',
		globalName: 'FavCams'
	});
	U.FavStoreStation = U.FavStoreStation || U.createFavStore('favStations', {
		eventName: 'favstationchange',
		globalName: 'FavStations'
	});
	U.FavStoreMuni = U.FavStoreMuni || U.createFavStore('favMuni', {
		eventName: 'favchange',
		globalName: 'FavStore'
	});
	U.FavStorePDF = U.FavStorePDF || U.createFavStore('favPdfs', {
		eventName: 'favpdfchange',
		globalName: 'FavPdfs'
	});
})();
